import React, { useState, useEffect } from "react";
import FormikControl from '../../../hoc/formikComponents/FormikControl.js'
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import { Formik, Form, Field, ErrorMessage ,FieldArray} from "formik";
import * as Yup from "yup";
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import moment from 'moment'
import Select from 'react-select';
import { APIURL } from "../../../hoc/AxiosSetting/axios.js";
import axios from "axios";
import * as AiIcons from 'react-icons/ai';
import swal from '@sweetalert/with-react';
import  {BrowserRouter as Router,Route,Switch,Redirect}  from "react-router-dom"

function Stage1AuditReport() {
    const history = useHistory();
    const [leadauditorList, setLeadauditorList] = useState([{
        label: "",
        value: ""
    }])
    const [assitAuditorList, setassitAuditorList] = useState([{
        label: "",
        value: ""
    }])
    const [technicalExpertList, setTechnicalExpertList] = useState([{
        label: "",
        value: ""
    }])

    const [auditorList, setauditorList] = useState([{
        label: "",
        value: ""
    }])
    const [initialValues, setInitialValues] = useState({
        orgCode: 0,
        address: "",
        siteofaddress: "",
        total: "",
        dateofaudit: new Date(),
        mobile: "",
        email: "",
        noofserver: "",
        noofwspclp: "",
        datacenterdetails: "",
        noofappluser: "",
        noofinfrauser: "",
        noofappdev: "",
        scope: "",
        auditobject: "",
        teamleader: "",
        teamleaderName: "",
        auditorOne: "",
        auditorOneName: "",
        auditorTwo: "",
        auditorTwoName: "",
        nabcbSicCode: "",
        nabcbSicCodeName: "",
        areqquatedmandays: "No",
        istherechangeemployee: "No",
        istherechangescope: "No",
        isthereanyinforevent: "No",

        auditdate1: new Date(),
        auditdate2: new Date(),
        technicalexpert: "",
        technicalExpertName: "",

        stageOneAudit: "",
        stageTwoAudit: "",
        typeofcontrolsfiveone: "OC",
        systemtestingfiveOneremark: "",
        visualfiveOneremark: "",
        commentfiveOneremark: "",
        typeofstatusfiveOne: "O",

        typeofcontrolsfiveone1: "OC",
        systemtestingfiveOneremark1: "",
        visualfiveOneremark1: "",
        commentfiveOneremark1: "",
        typeofstatusfiveOne1: "O",

        typeofcontrolsfiveone2: "OC",
        systemtestingfiveOneremark2: "",
        visualfiveOneremark2: "",
        commentfiveOneremark2: "",
        typeofstatusfiveOne2: "O",

        typeofcontrolssixone: "OC",
        systemtestingsixOneremark: "",
        visualsixOneremark: "",
        commentsixOneremark: "",
        typeofstatussixOne: "O",

        typeofcontrolssixone1: "OC",
        systemtestingsixOneremark1: "",
        visualsixOneremark1: "",
        commentsixOneremark1: "",
        typeofstatussixOne1: "O",

        typeofcontrolssixone2: "OC",
        systemtestingsixOneremark2: "",
        visualsixOneremark2: "",
        commentsixOneremark2: "",
        typeofstatussixOne2: "O",

        typeofcontrolssixone3: "OC",
        systemtestingsixOneremark3: "",
        visualsixOneremark3: "",
        commentsixOneremark3: "",
        typeofstatussixOne3: "O",

        typeofcontrolssixone4: "OC",
        systemtestingsixOneremark4: "",
        visualsixOneremark4: "",
        commentsixOneremark4: "",
        typeofstatussixOne4: "O",

        typeofcontrolssixone5: "OC",
        systemtestingsixOneremark: "",
        visualsixOneremark5: "",
        commentsixOneremark5: "",
        typeofstatussixOne5: "O",


        typeofcontrolssixtwo: "OC",
        systemtestingsixtworemark: "",
        visualsixtworemark: "",
        commentsixtworemark: "",
        typeofstatussixtwo: "O",

        typeofcontrolssixtwo1: "OC",
        systemtestingsixtworemark1: "",
        visualsixtworemark1: "",
        commentsixtworemark1: "",
        typeofstatussixtwo1: "O",

        typeofcontrolssixtwo2: "OC",
        systemtestingsixtworemark2: "",
        visualsixtworemark2: "",
        commentsixtworemark2: "",
        typeofstatussixtwo2: "O",

        typeofcontrolssevenone: "OC",
        systemtestingsevenOneremark: "",
        visualsixsevenOneremark: "",
        commentsixsevenOneremark: "",
        typeofstatussevenOne: "O",

        typeofcontrolssevenone1: "OC",
        systemtestingsevenOneremark1: "",
        visualsixsevenOneremark1: "",
        commentsixsevenOneremark1: "",
        typeofstatussevenOne1: "O",

        typeofcontrolssevenone2: "OC",
        systemtestingsevenOneremark2: "",
        visualsixsevenOneremark2: "",
        commentsixsevenOneremark2: "",
        typeofstatussevenOne2: "O",

        typeofcontrolsseventwo: "OC",
        systemtestingseventworemark: "",
        visualsixseventworemark: "",
        commentsixseventworemark: "",
        typeofstatusseventwo: "O",

        typeofcontrolsseventwo1: "OC",
        systemtestingseventworemark1: "",
        visualsixseventworemark1: "",
        commentsixseventworemark1: "",
        typeofstatusseventwo1: "O",

        typeofcontrolsseventwo2: "OC",
        systemtestingseventworemark2: "",
        visualsixseventworemark2: "",
        commentsixseventworemark2: "",
        typeofstatusseventwo2: "O",

        typeofcontrolsseventwo3: "OC",
        systemtestingseventworemark3: "",
        visualsixseventworemark3: "",
        commentsixseventworemark3: "",
        typeofstatusseventwo3: "O",

        typeofcontrolsseventhree: "OC",
        systemtestingseventhreeremark: "",
        visualsixseventhreeremark: "",
        commentsixseventhreeremark: "",
        typeofstatusseventhree: "O",

        typeofcontrolsseventhree1: "OC",
        systemtestingseventhreeremark1: "",
        visualsixseventhreeremark1: "",
        commentsixseventhreeremark1: "",
        typeofstatusseventhree1: "O",

        typeofcontrolseightone: "OC",
        systemtestingeightoneremark: "",
        visualeightoneremark: "",
        typeofstatuseightone: "O",
        commenteightoneremark: "",

        typeofcontrolseightone1: "OC",
        systemtestingeightoneremark1: "",
        visualeightoneremark1: "",
        typeofstatuseightone1: "O",
        commenteightoneremark1: "",

        typeofcontrolseightone2: "OC",
        systemtestingeightoneremark2: "",
        visualeightoneremark2: "",
        typeofstatuseightone2: "O",
        commenteightoneremark2: "",

        typeofcontrolseightone3: "OC",
        systemtestingeightoneremark3: "",
        visualeightoneremark3: "",
        typeofstatuseightone3: "O",
        commenteightoneremark3: "",

        typeofcontrolseightone4: "OC",
        systemtestingeightoneremark4: "",
        visualeightoneremark4: "",
        typeofstatuseightone4: "O",
        commenteightoneremark4: "",

        typeofcontrolseighttwo: "OC",
        systemtestingeighttworemark: "",
        visualeighttworemark: "",
        typeofstatuseighttwo: "O",
        commenteighttworemark: "",

        typeofcontrolseighttwo1: "OC",
        systemtestingeighttworemark1: "",
        visualeighttworemark1: "",
        typeofstatuseighttwo1: "O",
        commenteighttworemark1: "",


        typeofcontrolseighttwo2: "OC",
        systemtestingeighttworemark2: "",
        visualeighttworemark2: "",
        typeofstatuseighttwo2: "O",
        commenteighttworemark2: "",

        typeofcontrolseighttwo3: "OC",
        systemtestingeighttworemark3: "",
        visualeighttworemark3: "",
        typeofstatuseighttwo3: "O",
        commenteighttworemark3: "",

        typeofcontrolseightthree: "OC",
        systemtestingeightthreeremark: "",
        visualeightthreeremark: "",
        typeofstatuseightthree: "O",
        commenteightthreeremark: "",

        typeofcontrolseightthree1: "OC",
        systemtestingeightthreeremark1: "",
        visualeightthreeremark1: "",
        typeofstatuseightthree1: "O",
        commenteightthreeremark1: "",

        typeofcontrolseightthree2: "OC",
        systemtestingeightthreeremark2: "",
        visualeightthreeremark2: "",
        typeofstatuseightthree2: "O",
        commenteightthreeremark2: "",

        typeofcontrolseightthree3: "OC",
        systemtestingeightthreeremark3: "",
        visualeightthreeremark3: "",
        typeofstatuseightthree3: "O",
        commenteightthreeremark3: "",

        typeofcontrolsnineone: "OC",
        systemtestingnineoneremark: "",
        visualnineoneremark: "",
        typeofstatusnineone: "O",
        commentnineoneremark: "",

        typeofcontrolsnineone1: "OC",
        systemtestingnineoneremark1: "",
        visualnineoneremark1: "",
        typeofstatusnineone1: "O",
        commentnineoneremark1: "",

        typeofcontrolsnineone2: "OC",
        systemtestingnineoneremark2: "",
        visualnineoneremark2: "",
        typeofstatusnineone2: "O",
        commentnineoneremark2: "",

        typeofcontrolsninetwo: "OC",
        systemtestingninetworemark: "",
        visualninetworemark: "",
        typeofstatusninetwo: "O",
        commentninetworemark: "",

        typeofcontrolsninetwo1: "OC",
        systemtestingninetworemark1: "",
        visualninetworemark1: "",
        typeofstatusninetwo1: "O",
        commentninetworemark1: "",


        typeofcontrolsninetwo2: "OC",
        systemtestingninetworemark2: "",
        visualninetworemark2: "",
        typeofstatusninetwo2: "O",
        commentninetworemark2: "",

        typeofcontrolsninetwo3: "OC",
        systemtestingninetworemark3: "",
        visualninetworemark3: "",
        typeofstatusninetwo3: "O",
        commentninetworemark3: "",

        typeofcontrolsninetwo4: "OC",
        systemtestingninetworemark4: "",
        visualninetworemark4: "",
        typeofstatusninetwo4: "O",
        commentninetworemark4: "",

        typeofcontrolsninetwo5: "OC",
        systemtestingninetworemark5: "",
        visualninetworemark5: "",
        typeofstatusninetwo5: "O",
        commentninetworemark5: "",

        typeofcontrolsninetwo6: "OC",
        systemtestingninetworemark6: "",
        visualninetworemark6: "",
        typeofstatusninetwo6: "O",
        commentninetworemark6: "",


        typeofcontrolsninethree: "OC",
        systemtestingninethreeremark: "",
        visualninethreeremark: "",
        typeofstatusninethree: "O",
        commentninethreeremark: "",

        typeofcontrolsninethree1: "OC",
        systemtestingninethreeremark1: "",
        visualninethreeremark1: "",
        typeofstatusninethree1: "O",
        commentninethreeremark1: "",

        typeofcontrolsninefour: "OC",
        systemtestingninefourremark: "",
        visualninefourremark: "",
        typeofstatusninefour: "O",
        commentninefourremark: "",

        typeofcontrolsninefour1: "OC",
        systemtestingninefourremark1: "",
        visualninefourremark1: "",
        typeofstatusninefour1: "O",
        commentninefourremark1: "",

        typeofcontrolsninefour2: "OC",
        systemtestingninefourremark2: "",
        visualninefourremark2: "",
        typeofstatusninefour2: "O",
        commentninefourremark2: "",

        typeofcontrolsninefour3: "OC",
        systemtestingninefourremark3: "",
        visualninefourremark3: "",
        typeofstatusninefour3: "O",
        commentninefourremark3: "",

        typeofcontrolsninefour4: "OC",
        systemtestingninefourremark4: "",
        visualninefourremark4: "",
        typeofstatusninefour4: "O",
        commentninefourremark4: "",

        typeofcontrolsninefour5: "OC",
        systemtestingninefourremark5: "",
        visualninefourremark5: "",
        typeofstatusninefour5: "O",
        commentninefourremark5: "",

        typeofcontrolstenone: "OC",
        systemtestingtenoneremark: "",
        visualtenoneremark: "",
        typeofstatustenone: "O",
        commenttenoneremark: "",

        typeofcontrolstenone1: "OC",
        systemtestingtenoneremark1: "",
        visualtenoneremark1: "",
        typeofstatustenone1: "O",
        commenttenoneremark1: "",

        typeofcontrolstenone2: "OC",
        systemtestingtenoneremark2: "",
        visualtenoneremark2: "",
        typeofstatustenone2: "O",
        commenttenoneremark2: "",

        typeofcontrolselevenone: "OC",
        systemtestingelevenoneremark: "",
        visualelevenoneremark: "",
        typeofstatuselevenone: "O",
        commentelevenoneremark: "",

        typeofcontrolselevenone1: "OC",
        systemtestingelevenoneremark1: "",
        visualelevenoneremark1: "",
        typeofstatuselevenone1: "O",
        commentelevenoneremark1: "",

        typeofcontrolselevenone2: "OC",
        systemtestingelevenoneremark2: "",
        visualelevenoneremark2: "",
        typeofstatuselevenone2: "O",
        commentelevenoneremark2: "",

        typeofcontrolselevenone3: "OC",
        systemtestingelevenoneremark3: "",
        visualelevenoneremark3: "",
        typeofstatuselevenone3: "O",
        commentelevenoneremark3: "",

        typeofcontrolselevenone4: "OC",
        systemtestingelevenoneremark4: "",
        visualelevenoneremark4: "",
        typeofstatuselevenone4: "O",
        commentelevenoneremark4: "",

        typeofcontrolselevenone5: "OC",
        systemtestingelevenoneremark5: "",
        visualelevenoneremark5: "",
        typeofstatuselevenone5: "O",
        commentelevenoneremark5: "",

        typeofcontrolselevenone6: "OC",
        systemtestingelevenoneremark6: "",
        visualelevenoneremark6: "",
        typeofstatuselevenone6: "O",
        commentelevenoneremark6: "",

        typeofcontrolseleventwo: "OC",
        systemtestingeleventworemark: "",
        visualeleventworemark: "",
        typeofstatuseleventwo: "O",
        commenteleventworemark: "",

        typeofcontrolseleventwo1: "OC",
        systemtestingeleventworemark1: "",
        visualeleventworemark1: "",
        typeofstatuseleventwo1: "O",
        commenteleventworemark1: "",

        typeofcontrolseleventwo2: "OC",
        systemtestingeleventworemark2: "",
        visualeleventworemark2: "",
        typeofstatuseleventwo2: "O",
        commenteleventworemark2: "",

        typeofcontrolseleventwo3: "OC",
        systemtestingeleventworemark3: "",
        visualeleventworemark3: "",
        typeofstatuseleventwo3: "O",
        commenteleventworemark3: "",

        typeofcontrolseleventwo4: "OC",
        systemtestingeleventworemark4: "",
        visualeleventworemark4: "",
        typeofstatuseleventwo4: "O",
        commenteleventworemark4: "",

        typeofcontrolseleventwo5: "OC",
        systemtestingeleventworemark5: "",
        visualeleventworemark5: "",
        typeofstatuseleventwo5: "O",
        commenteleventworemark5: "",

        typeofcontrolseleventwo6: "OC",
        systemtestingeleventworemark6: "",
        visualeleventworemark6: "",
        typeofstatuseleventwo6: "O",
        commenteleventworemark6: "",

        typeofcontrolseleventwo7: "OC",
        systemtestingeleventworemark7: "",
        visualeleventworemark7: "",
        typeofstatuseleventwo7: "O",
        commenteleventworemark7: "",

        typeofcontrolseleventwo8: "OC",
        systemtestingeleventworemark8: "",
        visualeleventworemark8: "",
        typeofstatuseleventwo8: "O",
        commenteleventworemark8: "",

        typeofcontrolseleventwo9: "OC",
        systemtestingeleventworemark9: "",
        visualeleventworemark9: "",
        typeofstatuseleventwo9: "O",
        commenteleventworemark9: "",

        typeofcontrolstwelveone: "OC",
        systemtestingtwelveoneremark: "",
        visualtwelveoneremark: "",
        typeofstatustwelveone: "O",
        commenttwelveoneremark: "",

        typeofcontrolstwelveone1: "OC",
        systemtestingtwelveoneremark1: "",
        visualtwelveoneremark1: "",
        typeofstatustwelveone1: "O",
        commenttwelveoneremark1: "",

        typeofcontrolstwelveone2: "OC",
        systemtestingtwelveoneremark2: "",
        visualtwelveoneremark2: "",
        typeofstatustwelveone2: "O",
        commenttwelveoneremark2: "",

        typeofcontrolstwelveone3: "OC",
        systemtestingtwelveoneremark3: "",
        visualtwelveoneremark3: "",
        typeofstatustwelveone3: "O",
        commenttwelveoneremark3: "",

        typeofcontrolstwelveone5: "OC",
        systemtestingtwelveoneremark5: "",
        visualtwelveoneremark5: "",
        typeofstatustwelveone5: "O",
        commenttwelveoneremark5: "",

        typeofcontrolstwelvetwo: "OC",
        systemtestingtwelvetworemark: "",
        visualtwelvetworemark: "",
        typeofstatustwelvetwo: "O",
        commenttwelvetworemark: "",

        typeofcontrolstwelvetwo1: "OC",
        systemtestingtwelvetworemark1: "",
        visualtwelvetworemark1: "",
        typeofstatustwelvetwo1: "O",
        commenttwelvetworemark1: "",

        typeofcontrolstwelvethree: "OC",
        systemtestingtwelvethreeremark: "",
        visualtwelvethreeremark: "",
        typeofstatustwelvethree: "O",
        commenttwelvethreeremark: "",

        typeofcontrolstwelvethree1: "OC",
        systemtestingtwelvethreeremark1: "",
        visualtwelvethreeremark1: "",
        typeofstatustwelvethree1: "O",
        commenttwelvethreeremark1: "",

        typeofcontrolstwelvefour: "OC",
        systemtestingtwelvefourremark: "",
        visualtwelvefourremark: "",
        typeofstatustwelvefour: "O",
        commenttwelvefourremark: "",

        typeofcontrolstwelvefour1: "OC",
        systemtestingtwelvefourremark1: "",
        visualtwelvefourremark1: "",
        typeofstatustwelvefour1: "O",
        commenttwelvefourremark1: "",

        typeofcontrolstwelvefour2: "OC",
        systemtestingtwelvefourremark2: "",
        visualtwelvefourremark2: "",
        typeofstatustwelvefour2: "O",
        commenttwelvefourremark2: "",

        typeofcontrolstwelvefour3: "OC",
        systemtestingtwelvefourremark3: "",
        visualtwelvefourremark3: "",
        typeofstatustwelvefour3: "O",
        commenttwelvefourremark3: "",

        typeofcontrolstwelvefour4: "OC",
        systemtestingtwelvefourremark4: "",
        visualtwelvefourremark4: "",
        typeofstatustwelvefour4: "O",
        commenttwelvefourremark4: "",

        typeofcontrolstwelvefive: "OC",
        systemtestingtwelvefiveremark: "",
        visualtwelvefiveremark: "",
        typeofstatustwelvefive: "O",
        commenttwelvefiveremark: "",

        typeofcontrolstwelvefive1: "OC",
        systemtestingtwelvefiveremark1: "",
        visualtwelvefiveremark1: "",
        typeofstatustwelvefive1: "O",
        commenttwelvefiveremark1: "",

        typeofcontrolstwelvesix: "OC",
        systemtestingtwelvesixremark: "",
        visualtwelvesixremark: "",
        typeofstatustwelvesix: "O",
        commenttwelvesixremark: "",

        typeofcontrolstwelvesix1: "OC",
        systemtestingtwelvesixremark1: "",
        visualtwelvesixremark1: "",
        typeofstatustwelvesix1: "O",
        commenttwelvesixremark1: "",

        typeofcontrolstwelvesix2: "OC",
        systemtestingtwelvesixremark2: "",
        visualtwelvesixremark2: "",
        typeofstatustwelvesix2: "O",
        commenttwelvesixremark2: "",

        typeofcontrolstwelveseven: "OC",
        systemtestingtwelvesevenremark: "",
        visualtwelvesevenremark: "",
        typeofstatustwelveseven: "O",
        commenttwelvesevenremark: "",

        typeofcontrolstwelveseven1: "OC",
        systemtestingtwelvesevenremark1: "",
        visualtwelvesevenremark1: "",
        typeofstatustwelveseven1: "O",
        commenttwelvesevenremark1: "",

        typeofcontrolsthirteenone: "OC",
        systemtestingthirteenoneremark: "",
        visualthirteenoneremark: "",
        typeofstatusthirteenone: "O",
        commentthirteenoneremark: "",

        typeofcontrolsthirteenone1: "OC",
        systemtestingthirteenoneremark1: "",
        visualthirteenoneremark1: "",
        typeofstatusthirteenone1: "O",
        commentthirteenoneremark1: "",

        typeofcontrolsthirteenone2: "OC",
        systemtestingthirteenoneremark2: "",
        visualthirteenoneremark2: "",
        typeofstatusthirteenone2: "O",
        commentthirteenoneremark2: "",

        typeofcontrolsthirteenone3: "OC",
        systemtestingthirteenoneremark3: "",
        visualthirteenoneremark3: "",
        typeofstatusthirteenone3: "O",
        commentthirteenoneremark3: "",

        typeofcontrolsthirteentwo: "OC",
        systemtestingthirteentworemark: "",
        visualthirteentworemark: "",
        typeofstatusthirteentwo: "O",
        commentthirteentworemark: "",

        typeofcontrolsthirteentwo1: "OC",
        systemtestingthirteentworemark1: "",
        visualthirteentworemark1: "",
        typeofstatusthirteentwo1: "O",
        commentthirteentworemark1: "",

        typeofcontrolsthirteentwo2: "OC",
        systemtestingthirteentworemark2: "",
        visualthirteentworemark2: "",
        typeofstatusthirteentwo2: "O",
        commentthirteentworemark2: "",

        typeofcontrolsthirteentwo3: "OC",
        systemtestingthirteentworemark3: "",
        visualthirteentworemark3: "",
        typeofstatusthirteentwo3: "O",
        commentthirteentworemark3: "",

        typeofcontrolsthirteentwo4: "OC",
        systemtestingthirteentworemark4: "",
        visualthirteentworemark4: "",
        typeofstatusthirteentwo4: "O",
        commentthirteentworemark4: "",

        typeofcontrolsfourteenone: "OC",
        systemtestingfourteenoneremark: "",
        visualfourteenoneremark: "",
        typeofstatusfourteenone: "O",
        commentfourteenoneremark: "",

        typeofcontrolsfourteenone1: "OC",
        systemtestingfourteenoneremark1: "",
        visualfourteenoneremark1: "",
        typeofstatusfourteenone1: "O",
        commentfourteenoneremark1: "",

        typeofcontrolsfourteenone2: "OC",
        systemtestingfourteenoneremark2: "",
        visualfourteenoneremark2: "",
        typeofstatusfourteenone2: "O",
        commentfourteenoneremark2: "",

        typeofcontrolsfourteenone3: "OC",
        systemtestingfourteenoneremark3: "",
        visualfourteenoneremark3: "",
        typeofstatusfourteenone3: "O",
        commentfourteenoneremark3: "",

        typeofcontrolsfourteentwo: "OC",
        systemtestingfourteentworemark: "",
        visualfourteentworemark: "",
        typeofstatusfourteentwo: "O",
        commentfourteentworemark: "",

        typeofcontrolsfourteentwo1: "OC",
        systemtestingfourteentworemark1: "",
        visualfourteentworemark1: "",
        typeofstatusfourteentwo1: "O",
        commentfourteentworemark1: "",

        typeofcontrolsfourteentwo2: "OC",
        systemtestingfourteentworemark2: "",
        visualfourteentworemark2: "",
        typeofstatusfourteentwo2: "O",
        commentfourteentworemark2: "",

        typeofcontrolsfourteentwo3: "OC",
        systemtestingfourteentworemark3: "",
        visualfourteentworemark3: "",
        typeofstatusfourteentwo3: "O",
        commentfourteentworemark3: "",

        typeofcontrolsfourteentwo4: "OC",
        systemtestingfourteentworemark4: "",
        visualfourteentworemark4: "",
        typeofstatusfourteentwo4: "O",
        commentfourteentworemark4: "",

        typeofcontrolsfourteentwo5: "OC",
        systemtestingfourteentworemark5: "",
        visualfourteentworemark5: "",
        typeofstatusfourteentwo5: "O",
        commentfourteentworemark5: "",

        typeofcontrolsfourteentwo6: "OC",
        systemtestingfourteentworemark6: "",
        visualfourteentworemark6: "",
        typeofstatusfourteentwo6: "O",
        commentfourteentworemark6: "",

        typeofcontrolsfourteentwo7: "OC",
        systemtestingfourteentworemark7: "",
        visualfourteentworemark7: "",
        typeofstatusfourteentwo7: "O",
        commentfourteentworemark7: "",

        typeofcontrolsfourteentwo8: "OC",
        systemtestingfourteentworemark8: "",
        visualfourteentworemark8: "",
        typeofstatusfourteentwo8: "O",
        commentfourteentworemark8: "",

        typeofcontrolsfourteentwo9: "OC",
        systemtestingfourteentworemark9: "",
        visualfourteentworemark9: "",
        typeofstatusfourteentwo9: "O",
        commentfourteentworemark9: "",

        typeofcontrolsfourteenthree: "OC",
        systemtestingfourteenthreeremark: "",
        visualfourteenthreeremark: "",
        typeofstatusfourteenthree: "O",
        commentfourteenthreeremark: "",

        typeofcontrolsfourteenthree1: "OC",
        systemtestingfourteenthreeremark1: "",
        visualfourteenthreeremark1: "",
        typeofstatusfourteenthree1: "O",
        commentfourteenthreeremark1: "",

        typeofcontrolsfifteenone: "OC",
        systemtestingfifteenoneremark: "",
        visualfifteenoneremark: "",
        typeofstatusfifteenone: "O",
        commentfifteenoneremark: "",

        typeofcontrolsfifteenone1: "OC",
        systemtestingfifteenoneremark1: "",
        visualfifteenoneremark1: "",
        typeofstatusfifteenone1: "O",
        commentfifteenoneremark1: "",

        typeofcontrolsfifteenone2: "OC",
        systemtestingfifteenoneremark2: "",
        visualfifteenoneremark2: "",
        typeofstatusfifteenone2: "O",
        commentfifteenoneremark2: "",

        typeofcontrolsfifteenone3: "OC",
        systemtestingfifteenoneremark3: "",
        visualfifteenoneremark3: "",
        typeofstatusfifteenone3: "O",
        commentfifteenoneremark3: "",

        typeofcontrolsfifteentwo: "OC",
        systemtestingfifteentworemark: "",
        visualfifteentworemark: "",
        typeofstatusfifteentwo: "O",
        commentfifteentworemark: "",

        typeofcontrolsfifteentwo1: "OC",
        systemtestingfifteentworemark1: "",
        visualfifteentworemark1: "",
        typeofstatusfifteentwo1: "O",
        commentfifteentworemark1: "",

        typeofcontrolsfifteentwo2: "OC",
        systemtestingfifteentworemark2: "",
        visualfifteentworemark2: "",
        typeofstatusfifteentwo2: "O",
        commentfifteentworemark2: "",

        typeofcontrolssixteenone: "OC",
        systemtestingsixteenoneremark: "",
        visualsixteenoneremark: "",
        typeofstatussixteenone: "O",
        commentsixteenoneremark: "",

        typeofcontrolssixteenone1: "OC",
        systemtestingsixteenoneremark1: "",
        visualsixteenoneremark1: "",
        typeofstatussixteenone1: "O",
        commentsixteenoneremark1: "",

        typeofcontrolssixteenone2: "OC",
        systemtestingsixteenoneremark2: "",
        visualsixteenoneremark2: "",
        typeofstatussixteenone2: "O",
        commentsixteenoneremark2: "",

        typeofcontrolssixteenone3: "OC",
        systemtestingsixteenoneremark3: "",
        visualsixteenoneremark3: "",
        typeofstatussixteenone3: "O",
        commentsixteenoneremark3: "",

        typeofcontrolssixteenone4: "OC",
        systemtestingsixteenoneremark4: "",
        visualsixteenoneremark4: "",
        typeofstatussixteenone4: "O",
        commentsixteenoneremark4: "",

        typeofcontrolssixteenone5: "OC",
        systemtestingsixteenoneremark5: "",
        visualsixteenoneremark5: "",
        typeofstatussixteenone5: "O",
        commentsixteenoneremark5: "",

        typeofcontrolssixteenone6: "OC",
        systemtestingsixteenoneremark6: "",
        visualsixteenoneremark6: "",
        typeofstatussixteenone6: "O",
        commentsixteenoneremark6: "",

        typeofcontrolssixteenone7: "OC",
        systemtestingsixteenoneremark7: "",
        visualsixteenoneremark7: "",
        typeofstatussixteenone7: "O",
        commentsixteenoneremark7: "",

        typeofcontrolsseventeenone: "OC",
        systemtestingseventeenoneremark: "",
        visualseventeenoneremark: "",
        typeofstatusseventeenone: "O",
        commentseventeenoneremark: "",

        typeofcontrolsseventeenone1: "OC",
        systemtestingseventeenoneremark1: "",
        visualseventeenoneremark1: "",
        typeofstatusseventeenone1: "O",
        commentseventeenoneremark1: "",

        typeofcontrolsseventeenone2: "OC",
        systemtestingseventeenoneremark2: "",
        visualseventeenoneremark2: "",
        typeofstatusseventeenone2: "O",
        commentseventeenoneremark2: "",

        typeofcontrolsseventeenone3: "OC",
        systemtestingseventeenoneremark3: "",
        visualseventeenoneremark3: "",
        typeofstatusseventeenone3: "O",
        commentseventeenoneremark3: "",

        typeofcontrolsseventeentwo: "OC",
        systemtestingseventeentworemark: "",
        visualseventeentworemark: "",
        typeofstatusseventeentwo: "O",
        commentseventeentworemark: "",

        typeofcontrolsseventeentwo1: "OC",
        systemtestingseventeentworemark1: "",
        visualseventeentworemark1: "",
        typeofstatusseventeentwo1: "O",
        commentseventeentworemark1: "",

        typeofcontrolseighteenone: "OC",
        systemtestingeighteenoneremark: "",
        visualeighteenoneremark: "",
        typeofstatuseighteenone: "O",
        commenteighteenoneremark: "",

        typeofcontrolseighteenone1: "OC",
        systemtestingeighteenoneremark1: "",
        visualeighteenoneremark1: "",
        typeofstatuseighteenone1: "O",
        commenteighteenoneremark1: "",

        typeofcontrolseighteenone2: "OC",
        systemtestingeighteenoneremark2: "",
        visualeighteenoneremark2: "",
        typeofstatuseighteenone2: "O",
        commenteighteenoneremark2: "",

        typeofcontrolseighteenone3: "OC",
        systemtestingeighteenoneremark3: "",
        visualeighteenoneremark3: "",
        typeofstatuseighteenone3: "O",
        commenteighteenoneremark3: "",

        typeofcontrolseighteenone4: "OC",
        systemtestingeighteenoneremark4: "",
        visualeighteenoneremark4: "",
        typeofstatuseighteenone4: "O",
        commenteighteenoneremark4: "",

        typeofcontrolseighteenone5: "OC",
        systemtestingeighteenoneremark5: "",
        visualeighteenoneremark5: "",
        typeofstatuseighteenone5: "O",
        commenteighteenoneremark5: "",

        typeofcontrolseighteentwo: "OC",
        systemtestingeighteentworemark: "",
        visualeighteentworemark: "",
        typeofstatuseighteentwo: "O",
        commenteighteentworemark: "",

        typeofcontrolseighteentwo1: "OC",
        systemtestingeighteentworemark1: "",
        visualeighteentworemark1: "",
        typeofstatuseighteentwo1: "O",
        commenteighteentworemark1: "",

        typeofcontrolseighteentwo2: "OC",
        systemtestingeighteentworemark2: "",
        visualeighteentworemark2: "",
        typeofstatuseighteentwo2: "O",
        commenteighteentworemark2: "",

        typeofcontrolseighteentwo3: "OC",
        systemtestingeighteentworemark3: "",
        visualeighteentworemark3: "",
        typeofstatuseighteentwo3: "O",
        commenteighteentworemark3: "",


        processAuditReportDetails: [{
            nameofprocessid: "",
            nameofprocess: "",
            processowner: "",
            details: "",
            reference: "",
            comments: "",
            clauseWiseObservation: [{ clauseNo: "", Observation: "" }],
            clausesList: [{ label: "Select", value: "-" }]


        }],

    });
    const typeofcontrols = [
        { key: 'Select', value: '-' },
        { key: 'OC', value: 'OC' },
        { key: 'TC', value: 'Tc' },
        { key: 'OC,TC', value: 'OC,Tc' }
    ]
    const typeofstatus = [
        { key: 'Select', value: '-' },
        { key: 'O', value: 'O' },
        { key: 'C', value: 'C' },
        { key: 'N', value: 'N' },
        { key: 'NA', value: 'NA' }
    ]
    const options = [
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' }
    ]

    const ValidationSchema = Yup.object({
        orgCode: Yup.string().required('Required!!'),
        // reqDate                         :  Yup.string().required('Required!!'),
        contractDate: Yup.string().required('Required!!'),
        riskLevel: Yup.string().required('Required!!'),
        noOfShifts: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        sitesTobeCoveredInAudit: Yup.string().required('Required!!'),
        // nameOfConsultantOrBussinessAsso :  Yup.string().required('Required!!'),
        // mandays                         :  Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        mandaysPlanned: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        stageOneAudit: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        stageTwoAudit: Yup.string().required('Required!!').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),
        //  remarkforInsDecMandyas          :   Yup.string().required('Required!!'),
        //   resonOfTransfer                 :  Yup.string().required('Required!!'),
        //auditTrainVerification: Yup.string().required('Required!!'),
        // scopeCoveredByaccreditation: Yup.string().required('Required!!'),
        outSourceActivity: Yup.string().required('Required!!'),
        notApplicableRequirement: Yup.string().required('Required!!'),
        //applicationAcceptedRejected: Yup.string().required('Required!!'),
        //approvedBy: Yup.string().required('Required!!'),
        externalReviewConductedBy: Yup.string().required('Required!!'),
        reviewConductedBy: Yup.string().required('Required!!'),
        // appvDate                        :  Yup.string().required('Required!!'),
        certificateactivitytype: Yup.string().required('Required!!'),
        certificatestandardtype: Yup.string().required('Required!!'),
        teamleader: Yup.string().required('Required!!'),


    });
    const { data: processList, isLoading: processListLoading } = useQuery(
        'listprocess',
        () => Fetcher('get', '/api/clauses/get/listclauseswithkeylabel', {}))

    const { data: CertList, isLoading: certLoading } = useQuery(
        'listCert',
        () => Fetcher('get', '/api/typeofcertifications/get/typeofcertkeyvalue', {}))

    const onSubmit = (values, { setSubmitting, resetForm }) => {
        mutation.mutate(values)
        
        setTimeout(() => {
            alert(JSON.stringify(values, null, 2));
            //actions.setSubmitting(false);
            }, 500);
        //history.push("/" + localStorage.getItem("role") + '/stage1auditreport1/'+initialValues.orgCode );
            }
    const { orgcode } = useParams()


    const mutationAssisAuditorDetails = useMutation((params) => Fetcher('get', '/api/profile/get/keyvalueforAssistAuditorCommonNacecode/' + params, {}), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {
                console.log("List of Auditor", data.data.response)
                setassitAuditorList(data.data.response)

            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const mutationAuditorListDetails = useMutation((params) => Fetcher('get', '/api/profile/get/keyvalueforAuditorCommonNacecode/' + params, {}), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {
                console.log("List of Auditor", data.data.response)
                setauditorList(data.data.response)

            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const mutation = useMutation((params) => Fetcher('patch', '/api/rfq/patch/auditreportnew', params), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {
                ToastInstance('Success', 'Stage 1 Audit Report Data Added')
             
               history.push("/" + localStorage.getItem("role") + '/stage1auditreport1/'+initialValues.orgCode );
            } else {

                var msg = 'stage 1 audit report - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Contract Review' + error)
        }
    })

    const mutationgetCompanyDetails = useMutation((params) => Fetcher('get', '/api/rfq/get/orgdetails/' + params, {}), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {
                var tempInitialValues = data.data.response;
                console.log("tempInitialValues", tempInitialValues)

                tempInitialValues.siteofaddress = data.data.response.siteofaddress || "";
                tempInitialValues.auditobject = data.data.response.auditobject || "";
                tempInitialValues.dateofaudit = Date.parse(data.data.response.dateofaudit) || null;
                tempInitialValues.auditdate1 = Date.parse(data.data.response.auditdate1) || null;
                tempInitialValues.auditdate2 = Date.parse(data.data.response.auditdate2) || null;

                tempInitialValues.areqquatedmandays = data.data.response.areqquatedmandays || "No";
                tempInitialValues.istherechangeemployee = data.data.response.istherechangeemployee || "No";
                tempInitialValues.istherechangescope = data.data.response.istherechangescope || "No";
                tempInitialValues.isthereanyinforevent = data.data.response.isthereanyinforevent || "No";

                tempInitialValues.typeofcontrolsfiveone = data.data.response.typeofcontrolsfiveone || "OC";
                tempInitialValues.systemtestingfiveOneremark = data.data.response.systemtestingfiveOneremark || "";
                tempInitialValues.visualfiveOneremark = data.data.response.visualfiveOneremark || "";
                tempInitialValues.commentfiveOneremark = data.data.response.commentfiveOneremark || "";
                tempInitialValues.typeofstatusfiveOne = data.data.response.typeofstatusfiveOne || "O";

                tempInitialValues.typeofcontrolsfiveone1 = data.data.response.typeofcontrolsfiveone1 || "OC"
                tempInitialValues.systemtestingfiveOneremark1 = data.data.response.systemtestingfiveOneremark1 || "";
                tempInitialValues.visualfiveOneremark1 = data.data.response.visualfiveOneremark1 || "";
                tempInitialValues.commentfiveOneremark1 = data.data.response.commentfiveOneremark1 || "";
                tempInitialValues.typeofstatusfiveOne1 = data.data.response.typeofstatusfiveOne1 || "O";

                tempInitialValues.typeofcontrolsfiveone2 = data.data.response.typeofcontrolsfiveone2 || "OC"
                tempInitialValues.systemtestingfiveOneremark2 = data.data.response.systemtestingfiveOneremark2 || "";
                tempInitialValues.visualfiveOneremark2 = data.data.response.visualfiveOneremark2 || "";
                tempInitialValues.commentfiveOneremark2 = data.data.response.commentfiveOneremark2 || "";
                tempInitialValues.typeofstatusfiveOne2 = data.data.response.typeofstatusfiveOne2 || "O";

                tempInitialValues.typeofcontrolssixone = data.data.response.typeofcontrolssixone || "OC"
                tempInitialValues.systemtestingsixOneremark = data.data.response.systemtestingsixOneremark || "";
                tempInitialValues.visualsixOneremark = data.data.response.visualsixOneremark || "";
                tempInitialValues.commentsixOneremark = data.data.response.commentsixOneremark || "";
                tempInitialValues.typeofstatussixOne = data.data.response.typeofstatussixOne || "O";

                tempInitialValues.typeofcontrolssixone1 = data.data.response.typeofcontrolssixone1 || "OC";
                tempInitialValues.systemtestingsixOneremark1 = data.data.response.systemtestingsixOneremark1 || "";
                tempInitialValues.visualsixOneremark1 = data.data.response.visualsixOneremark1 || "";
                tempInitialValues.commentsixOneremark1 = data.data.response.commentsixOneremark1 || "";
                tempInitialValues.typeofstatussixOne1 = data.data.response.typeofstatussixOne1 || "O";

                tempInitialValues.typeofcontrolssixone2 = data.data.response.typeofcontrolssixone2 || "OC";
                tempInitialValues.systemtestingsixOneremark2 = data.data.response.systemtestingsixOneremark2 || "";
                tempInitialValues.visualsixOneremark2 = data.data.response.visualsixOneremark2 || "";
                tempInitialValues.commentsixOneremark2 = data.data.response.commentsixOneremark2 || "";
                tempInitialValues.typeofstatussixOne2 = data.data.response.typeofstatussixOne2 || "";

                tempInitialValues.typeofcontrolssixone3 = data.data.response.typeofcontrolssixone3 || "OC";
                tempInitialValues.systemtestingsixOneremark3 = data.data.response.systemtestingsixOneremark3 || "";
                tempInitialValues.visualsixOneremark3 = data.data.response.visualsixOneremark3 || "";
                tempInitialValues.commentsixOneremark3 = data.data.response.commentsixOneremark3 || "";
                tempInitialValues.typeofstatussixOne3 = data.data.response.typeofstatussixOne3 || "O";

                tempInitialValues.typeofcontrolssixone4 = data.data.response.typeofcontrolssixone4 || "OC";
                tempInitialValues.systemtestingsixOneremark4 = data.data.response.systemtestingsixOneremark4 || "";
                tempInitialValues.visualsixOneremark4 = data.data.response.visualsixOneremark4 || "";
                tempInitialValues.commentsixOneremark4 = data.data.response.commentsixOneremark4 || "";
                tempInitialValues.typeofstatussixOne4 = data.data.response.typeofstatussixOne4 || "O";

                tempInitialValues.typeofcontrolssixone5 = data.data.response.typeofcontrolssixone5 || "OC";
                tempInitialValues.systemtestingsixOneremark5 = data.data.response.systemtestingsixOneremark5 || "";
                tempInitialValues.visualsixOneremark5 = data.data.response.visualsixOneremark5 || "";
                tempInitialValues.commentsixOneremark5 = data.data.response.commentsixOneremark5 || "";
                tempInitialValues.typeofstatussixOne5 = data.data.response.typeofstatussixOne5 || "O";

                tempInitialValues.typeofcontrolssixtwo = data.data.response.typeofcontrolssixtwo || "OC";
                tempInitialValues.systemtestingsixtworemark = data.data.response.systemtestingsixtworemark || "";
                tempInitialValues.visualsixtworemark = data.data.response.visualsixtworemark || "";
                tempInitialValues.commentsixtworemark = data.data.response.commentsixtworemark || "";
                tempInitialValues.typeofstatussixtwo = data.data.response.typeofstatussixtwo || "O";

                tempInitialValues.typeofcontrolssixtwo1 = data.data.response.typeofcontrolssixtwo1 || "OC";
                tempInitialValues.systemtestingsixtworemark1 = data.data.response.systemtestingsixtworemark1 || "";
                tempInitialValues.visualsixtworemark1 = data.data.response.visualsixtworemark1 || "";
                tempInitialValues.commentsixtworemark1 = data.data.response.commentsixtworemark1 || "";
                tempInitialValues.typeofstatussixtwo1 = data.data.response.typeofstatussixtwo1 || "O";

                tempInitialValues.typeofcontrolssixtwo2 = data.data.response.typeofcontrolssixtwo2 || "OC";
                tempInitialValues.systemtestingsixtworemark2 = data.data.response.systemtestingsixtworemark2 || "";
                tempInitialValues.visualsixtworemark2 = data.data.response.visualsixtworemark2 || "";
                tempInitialValues.commentsixtworemark2 = data.data.response.commentsixtworemark2 || "";
                tempInitialValues.typeofstatussixtwo2 = data.data.response.typeofstatussixtwo2 || "O";

                tempInitialValues.typeofcontrolssevenone = data.data.response.typeofcontrolssevenone || "OC";
                tempInitialValues.systemtestingsevenOneremark = data.data.response.systemtestingsevenOneremark || "";
                tempInitialValues.visualsixsevenOneremark = data.data.response.visualsixsevenOneremark || "";
                tempInitialValues.commentsixsevenOneremark = data.data.response.commentsixsevenOneremark || "";
                tempInitialValues.typeofstatussevenOne = data.data.response.typeofstatussevenOne || "O";

                tempInitialValues.typeofcontrolssevenone1 = data.data.response.typeofcontrolssevenone1 || "OC";
                tempInitialValues.systemtestingsevenOneremark1 = data.data.response.systemtestingsevenOneremark1 || "";
                tempInitialValues.visualsixsevenOneremark1 = data.data.response.visualsixsevenOneremark1 || "";
                tempInitialValues.commentsixsevenOneremark1 = data.data.response.commentsixsevenOneremark1 || "";
                tempInitialValues.typeofstatussevenOne1 = data.data.response.typeofstatussevenOne1 || "O";

                tempInitialValues.typeofcontrolssevenone2 = data.data.response.typeofcontrolssevenone2 || "OC";
                tempInitialValues.systemtestingsevenOneremark2 = data.data.response.systemtestingsevenOneremark2 || "";
                tempInitialValues.visualsixsevenOneremark2 = data.data.response.visualsixsevenOneremark2 || "";
                tempInitialValues.commentsixsevenOneremark2 = data.data.response.commentsixsevenOneremark2 || "";
                tempInitialValues.typeofstatussevenOne2 = data.data.response.typeofstatussevenOne2 || "O";

                tempInitialValues.typeofcontrolsseventwo = data.data.response.typeofcontrolsseventwo || "OC";
                tempInitialValues.systemtestingseventworemark = data.data.response.systemtestingseventworemark || "";
                tempInitialValues.visualsixseventworemark = data.data.response.visualsixseventworemark || "";
                tempInitialValues.commentsixseventworemark = data.data.response.commentsixseventworemark || "";
                tempInitialValues.typeofstatusseventwo = data.data.response.typeofstatusseventwo || "O";

                tempInitialValues.typeofcontrolsseventwo1 = data.data.response.typeofcontrolsseventwo1 || "OC";
                tempInitialValues.systemtestingseventworemark1 = data.data.response.systemtestingseventworemark1 || "";
                tempInitialValues.visualsixseventworemark1 = data.data.response.visualsixseventworemark1 || "";
                tempInitialValues.commentsixseventworemark1 = data.data.response.commentsixseventworemark1 || "";
                tempInitialValues.typeofstatusseventwo1 = data.data.response.typeofstatusseventwo1 || "O";

                tempInitialValues.typeofcontrolsseventwo2 = data.data.response.typeofcontrolsseventwo2 || "OC";
                tempInitialValues.systemtestingseventworemark2 = data.data.response.systemtestingseventworemark2 || "";
                tempInitialValues.visualsixseventworemark2 = data.data.response.visualsixseventworemark2 || "";
                tempInitialValues.commentsixseventworemark2 = data.data.response.commentsixseventworemark2 || "";
                tempInitialValues.typeofstatusseventwo2 = data.data.response.typeofstatusseventwo2 || "O";

                tempInitialValues.typeofcontrolsseventwo3 = data.data.response.typeofcontrolsseventwo3 || "OC";
                tempInitialValues.systemtestingseventworemark3 = data.data.response.systemtestingseventworemark3 || "";
                tempInitialValues.visualsixseventworemark3 = data.data.response.visualsixseventworemark3 || "";
                tempInitialValues.commentsixseventworemark3 = data.data.response.commentsixseventworemark3 || "";
                tempInitialValues.typeofstatusseventwo3 = data.data.response.typeofstatusseventwo3 || "O";

                tempInitialValues.typeofcontrolsseventhree = data.data.response.typeofcontrolsseventhree || "OC";
                tempInitialValues.systemtestingseventhreeremark = data.data.response.systemtestingseventhreeremark || "";
                tempInitialValues.visualsixseventhreeremark = data.data.response.visualsixseventhreeremark || "";
                tempInitialValues.commentsixseventhreeremark = data.data.response.commentsixseventhreeremark || "";
                tempInitialValues.typeofstatusseventhree = data.data.response.typeofstatusseventhree || "O";

                tempInitialValues.typeofcontrolsseventhree1 = data.data.response.typeofcontrolsseventhree1 || "OC";
                tempInitialValues.systemtestingseventhreeremark1 = data.data.response.systemtestingseventhreeremark1 || "";
                tempInitialValues.visualsixseventhreeremark1 = data.data.response.visualsixseventhreeremark1 || "";
                tempInitialValues.commentsixseventhreeremark1 = data.data.response.commentsixseventhreeremark1 || "";
                tempInitialValues.typeofstatusseventhree1 = data.data.response.typeofstatusseventhree1 || "O";

                tempInitialValues.typeofcontrolseightone = data.data.response.typeofcontrolseightone || "OC";
                tempInitialValues.systemtestingeightoneremark = data.data.response.systemtestingeightoneremark || "";
                tempInitialValues.visualeightoneremark = data.data.response.visualeightoneremark || "";
                tempInitialValues.commenteightoneremark = data.data.response.commenteightoneremark || "";
                tempInitialValues.typeofstatuseightone = data.data.response.typeofstatuseightone || "O";

                tempInitialValues.typeofcontrolseightone1 = data.data.response.typeofcontrolseightone1 || "OC";
                tempInitialValues.systemtestingeightoneremark1 = data.data.response.systemtestingeightoneremark1 || "";
                tempInitialValues.visualeightoneremark1 = data.data.response.visualeightoneremark1 || "";
                tempInitialValues.commenteightoneremark1 = data.data.response.commenteightoneremark1 || "";
                tempInitialValues.typeofstatuseightone1 = data.data.response.typeofstatuseightone1 || "O";

                tempInitialValues.typeofcontrolseightone2 = data.data.response.typeofcontrolseightone2 || "OC"
                tempInitialValues.systemtestingeightoneremark2 = data.data.response.systemtestingeightoneremark2 || "";
                tempInitialValues.visualeightoneremark2 = data.data.response.visualeightoneremark2 || "";
                tempInitialValues.commenteightoneremark2 = data.data.response.commenteightoneremark2 || "";
                tempInitialValues.typeofstatuseightone2 = data.data.response.typeofstatuseightone2 || "O";

                tempInitialValues.typeofcontrolseightone3 = data.data.response.typeofcontrolseightone3 || "OC"
                tempInitialValues.systemtestingeightoneremark3 = data.data.response.systemtestingeightoneremark3 || "";
                tempInitialValues.visualeightoneremark3 = data.data.response.visualeightoneremark3 || "";
                tempInitialValues.commenteightoneremark3 = data.data.response.commenteightoneremark3 || "";
                tempInitialValues.typeofstatuseightone3 = data.data.response.typeofstatuseightone3 || "O";

                tempInitialValues.typeofcontrolseightone4 = data.data.response.typeofcontrolseightone4 || "OC";
                tempInitialValues.systemtestingeightoneremark4 = data.data.response.systemtestingeightoneremark4 || "";
                tempInitialValues.visualeightoneremark4 = data.data.response.visualeightoneremark4 || "";
                tempInitialValues.commenteightoneremark4 = data.data.response.commenteightoneremark4 || "";
                tempInitialValues.typeofstatuseightone4 = data.data.response.typeofstatuseightone4 || "O";

                tempInitialValues.typeofcontrolseighttwo = data.data.response.typeofcontrolseighttwo || "OC";
                tempInitialValues.systemtestingeighttworemark = data.data.response.systemtestingeighttworemark || "";
                tempInitialValues.visualeighttworemark = data.data.response.visualeighttworemark || "";
                tempInitialValues.commenteighttworemark = data.data.response.commenteighttworemark || "";
                tempInitialValues.typeofstatuseighttwo = data.data.response.typeofstatuseighttwo || "O";

                tempInitialValues.typeofcontrolseighttwo1 = data.data.response.typeofcontrolseighttwo1 || "OC";
                tempInitialValues.systemtestingeighttworemark1 = data.data.response.systemtestingeighttworemark1 || "";
                tempInitialValues.visualeighttworemark1 = data.data.response.visualeighttworemark1 || "";
                tempInitialValues.commenteighttworemark1 = data.data.response.commenteighttworemark1 || "";
                tempInitialValues.typeofstatuseighttwo1 = data.data.response.typeofstatuseighttwo1 || "O";

                tempInitialValues.typeofcontrolseighttwo2 = data.data.response.typeofcontrolseighttwo2 || "OC";
                tempInitialValues.systemtestingeighttworemark2 = data.data.response.systemtestingeighttworemark2 || "";
                tempInitialValues.visualeighttworemark2 = data.data.response.visualeighttworemark2 || "";
                tempInitialValues.commenteighttworemark2 = data.data.response.commenteighttworemark2 || "";
                tempInitialValues.typeofstatuseighttwo2 = data.data.response.typeofstatuseighttwo2 || "O";

                tempInitialValues.typeofcontrolseighttwo3 = data.data.response.typeofcontrolseighttwo3 || "OC";
                tempInitialValues.systemtestingeighttworemark3 = data.data.response.systemtestingeighttworemark3 || "";
                tempInitialValues.visualeighttworemark3 = data.data.response.visualeighttworemark3 || "";
                tempInitialValues.commenteighttworemark3 = data.data.response.commenteighttworemark3 || "";
                tempInitialValues.typeofstatuseighttwo3 = data.data.response.typeofstatuseighttwo3 || "O";

                tempInitialValues.typeofcontrolseightthree = data.data.response.typeofcontrolseightthree || "OC";
                tempInitialValues.systemtestingeightthreeremark = data.data.response.systemtestingeightthreeremark || "";
                tempInitialValues.visualeightthreeremark = data.data.response.visualeightthreeremark || "";
                tempInitialValues.commenteightthreeremark = data.data.response.commenteightthreeremark || "";
                tempInitialValues.typeofstatuseightthree = data.data.response.typeofstatuseightthree || "O";

                tempInitialValues.typeofcontrolseightthree1 = data.data.response.typeofcontrolseightthree1 || "OC";
                tempInitialValues.systemtestingeightthreeremark1 = data.data.response.systemtestingeightthreeremark1 || "";
                tempInitialValues.visualeightthreeremark1 = data.data.response.visualeightthreeremark1 || "";
                tempInitialValues.commenteightthreeremark1 = data.data.response.commenteightthreeremark1 || "";
                tempInitialValues.typeofstatuseightthree1 = data.data.response.typeofstatuseightthree1 || "O";

                tempInitialValues.typeofcontrolseightthree2 = data.data.response.typeofcontrolseightthree2 || "OC";
                tempInitialValues.systemtestingeightthreeremark2 = data.data.response.systemtestingeightthreeremark2 || "";
                tempInitialValues.visualeightthreeremark2 = data.data.response.visualeightthreeremark2 || "";
                tempInitialValues.commenteightthreeremark2 = data.data.response.commenteightthreeremark2 || "";
                tempInitialValues.typeofstatuseightthree2 = data.data.response.typeofstatuseightthree2 || "";

                tempInitialValues.typeofcontrolseightthree3 = data.data.response.typeofcontrolseightthree3 || "OC";
                tempInitialValues.systemtestingeightthreeremark3 = data.data.response.systemtestingeightthreeremark3 || "";
                tempInitialValues.visualeightthreeremark3 = data.data.response.visualeightthreeremark3 || "";
                tempInitialValues.commenteightthreeremark3 = data.data.response.commenteightthreeremark3 || "";
                tempInitialValues.typeofstatuseightthree3 = data.data.response.typeofstatuseightthree3 || "O";

                tempInitialValues.typeofcontrolsnineone = data.data.response.typeofcontrolsnineone || "OC";
                tempInitialValues.systemtestingnineoneremark = data.data.response.systemtestingnineoneremark || "";
                tempInitialValues.visualnineoneremark = data.data.response.visualnineoneremark || "";
                tempInitialValues.commentnineoneremark = data.data.response.commentnineoneremark || "";
                tempInitialValues.typeofstatusnineone = data.data.response.typeofstatusnineone || "O";

                tempInitialValues.typeofcontrolsnineone1 = data.data.response.typeofcontrolsnineone1 || "OC";
                tempInitialValues.systemtestingnineoneremark1 = data.data.response.systemtestingnineoneremark1 || "";
                tempInitialValues.visualnineoneremark1 = data.data.response.visualnineoneremark1 || "";
                tempInitialValues.commentnineoneremark1 = data.data.response.commentnineoneremark1 || "";
                tempInitialValues.typeofstatusnineone1 = data.data.response.typeofstatusnineone1 || "O";

                tempInitialValues.typeofcontrolsnineone2 = data.data.response.typeofcontrolsnineone2 || "OC"
                tempInitialValues.systemtestingnineoneremark2 = data.data.response.systemtestingnineoneremark2 || "";
                tempInitialValues.visualnineoneremark2 = data.data.response.visualnineoneremark2 || "";
                tempInitialValues.commentnineoneremark2 = data.data.response.commentnineoneremark2 || "";
                tempInitialValues.typeofstatusnineone2 = data.data.response.typeofstatusnineone2 || "O";

                tempInitialValues.typeofcontrolsninetwo = data.data.response.typeofcontrolsninetwo || "OC";
                tempInitialValues.systemtestingninetworemark = data.data.response.systemtestingninetworemark || "";
                tempInitialValues.visualninetworemark = data.data.response.visualninetworemark || "";
                tempInitialValues.commentninetworemark = data.data.response.commentninetworemark || "";
                tempInitialValues.typeofstatusninetwo = data.data.response.typeofstatusninetwo || "O";

                tempInitialValues.typeofcontrolsninetwo1 = data.data.response.typeofcontrolsninetwo1 || "OC";
                tempInitialValues.systemtestingninetworemark1 = data.data.response.systemtestingninetworemark1 || "";
                tempInitialValues.visualninetworemark1 = data.data.response.visualninetworemark1 || "";
                tempInitialValues.commentninetworemark1 = data.data.response.commentninetworemark1 || "";
                tempInitialValues.typeofstatusninetwo1 = data.data.response.typeofstatusninetwo1 || "O";

                tempInitialValues.typeofcontrolsninetwo2 = data.data.response.typeofcontrolsninetwo2 || "OC";
                tempInitialValues.systemtestingninetworemark2 = data.data.response.systemtestingninetworemark2 || "";
                tempInitialValues.visualninetworemark2 = data.data.response.visualninetworemark2 || "";
                tempInitialValues.commentninetworemark2 = data.data.response.commentninetworemark2 || "";
                tempInitialValues.typeofstatusninetwo2 = data.data.response.typeofstatusninetwo2 || "O";

                tempInitialValues.typeofcontrolsninetwo3 = data.data.response.typeofcontrolsninetwo3 || "OC";
                tempInitialValues.systemtestingninetworemark3 = data.data.response.systemtestingninetworemark3 || "";
                tempInitialValues.visualninetworemark3 = data.data.response.visualninetworemark3 || "";
                tempInitialValues.commentninetworemark3 = data.data.response.commentninetworemark3 || "";
                tempInitialValues.typeofstatusninetwo3 = data.data.response.typeofstatusninetwo3 || "O";

                tempInitialValues.typeofcontrolsninetwo4 = data.data.response.typeofcontrolsninetwo4 || "OC";
                tempInitialValues.systemtestingninetworemark4 = data.data.response.systemtestingninetworemark4 || "";
                tempInitialValues.visualninetworemark4 = data.data.response.visualninetworemark4 || "";
                tempInitialValues.commentninetworemark4 = data.data.response.commentninetworemark4 || "";
                tempInitialValues.typeofstatusninetwo4 = data.data.response.typeofstatusninetwo4 || "O";

                tempInitialValues.typeofcontrolsninetwo5 = data.data.response.typeofcontrolsninetwo5 || "OC"
                tempInitialValues.systemtestingninetworemark5 = data.data.response.systemtestingninetworemark5 || "";
                tempInitialValues.visualninetworemark5 = data.data.response.visualninetworemark5 || "";
                tempInitialValues.commentninetworemark5 = data.data.response.commentninetworemark5 || "";
                tempInitialValues.typeofstatusninetwo5 = data.data.response.typeofstatusninetwo5 || "O";

                tempInitialValues.typeofcontrolsninetwo6 = data.data.response.typeofcontrolsninetwo6 || "OC";
                tempInitialValues.systemtestingninetworemark6 = data.data.response.systemtestingninetworemark6 || "";
                tempInitialValues.visualninetworemark6 = data.data.response.visualninetworemark6 || "";
                tempInitialValues.commentninetworemark6 = data.data.response.commentninetworemark6 || "";
                tempInitialValues.typeofstatusninetwo6 = data.data.response.typeofstatusninetwo6 || "O";

                tempInitialValues.typeofcontrolsninethree = data.data.response.typeofcontrolsninethree || "OC";
                tempInitialValues.systemtestingninethreeremark = data.data.response.systemtestingninethreeremark || "";
                tempInitialValues.visualninethreeremark = data.data.response.visualninethreeremark || "";
                tempInitialValues.commentninethreeremark = data.data.response.commentninethreeremark || "";
                tempInitialValues.typeofstatusninethree = data.data.response.typeofstatusninethree || "O";

                tempInitialValues.typeofcontrolsninethree1 = data.data.response.typeofcontrolsninethree1 || "OC";
                tempInitialValues.systemtestingninethreeremark1 = data.data.response.systemtestingninethreeremark1 || "";
                tempInitialValues.visualninethreeremark1 = data.data.response.visualninethreeremark1 || "";
                tempInitialValues.commentninethreeremark1 = data.data.response.commentninethreeremark1 || "";
                tempInitialValues.typeofstatusninethree1 = data.data.response.typeofstatusninethree1 || "O";

                tempInitialValues.typeofcontrolsninefour = data.data.response.typeofcontrolsninefour || "OC";
                tempInitialValues.systemtestingninefourremark = data.data.response.systemtestingninefourremark || "";
                tempInitialValues.visualninefourremark = data.data.response.visualninefourremark || "";
                tempInitialValues.commentninefourremark = data.data.response.commentninefourremark || "";
                tempInitialValues.typeofstatusninefour = data.data.response.typeofstatusninefour || "O";

                tempInitialValues.typeofcontrolsninefour1 = data.data.response.typeofcontrolsninefour1 || "OC";
                tempInitialValues.systemtestingninefourremark1 = data.data.response.systemtestingninefourremark1 || "";
                tempInitialValues.visualninefourremark1 = data.data.response.visualninefourremark1 || "";
                tempInitialValues.commentninefourremark1 = data.data.response.commentninefourremark1 || "";
                tempInitialValues.typeofstatusninefour1 = data.data.response.typeofstatusninefour1 || "O";

                tempInitialValues.typeofcontrolsninefour2 = data.data.response.typeofcontrolsninefour2 || "OC";
                tempInitialValues.systemtestingninefourremark2 = data.data.response.systemtestingninefourremark2 || "";
                tempInitialValues.visualninefourremark2 = data.data.response.visualninefourremark2 || "";
                tempInitialValues.commentninefourremark2 = data.data.response.commentninefourremark2 || "";
                tempInitialValues.typeofstatusninefour2 = data.data.response.typeofstatusninefour2 || "O";

                tempInitialValues.typeofcontrolsninefour3 = data.data.response.typeofcontrolsninefour3 || "OC"
                tempInitialValues.systemtestingninefourremark3 = data.data.response.systemtestingninefourremark3 || "";
                tempInitialValues.visualninefourremark3 = data.data.response.visualninefourremark3 || "";
                tempInitialValues.commentninefourremark3 = data.data.response.commentninefourremark3 || "";
                tempInitialValues.typeofstatusninefour3 = data.data.response.typeofstatusninefour3 || "O";

                tempInitialValues.typeofcontrolsninefour4 = data.data.response.typeofcontrolsninefour4 || "OC";
                tempInitialValues.systemtestingninefourremark4 = data.data.response.systemtestingninefourremark4 || "";
                tempInitialValues.visualninefourremark4 = data.data.response.visualninefourremark4 || "";
                tempInitialValues.commentninefourremark4 = data.data.response.commentninefourremark4 || "";
                tempInitialValues.typeofstatusninefour4 = data.data.response.typeofstatusninefour4 || "O";

                tempInitialValues.typeofcontrolsninefour5 = data.data.response.typeofcontrolsninefour5 || "OC";
                tempInitialValues.systemtestingninefourremark5 = data.data.response.systemtestingninefourremark5 || "";
                tempInitialValues.visualninefourremark5 = data.data.response.visualninefourremark5 || "";
                tempInitialValues.commentninefourremark5 = data.data.response.commentninefourremark5 || "";
                tempInitialValues.typeofstatusninefour5 = data.data.response.typeofstatusninefour5 || "O";

                tempInitialValues.typeofcontrolstenone = data.data.response.typeofcontrolstenone || "OC";
                tempInitialValues.systemtestingtenoneremark = data.data.response.systemtestingtenoneremark || "";
                tempInitialValues.visualtenoneremark = data.data.response.visualtenoneremark || "";
                tempInitialValues.commenttenoneremark = data.data.response.commenttenoneremark || "";
                tempInitialValues.typeofstatustenone = data.data.response.typeofstatustenone || "O";

                tempInitialValues.typeofcontrolstenone1 = data.data.response.typeofcontrolstenone1 || "OC"
                tempInitialValues.systemtestingtenoneremark1 = data.data.response.systemtestingtenoneremark1 || "";
                tempInitialValues.visualtenoneremark1 = data.data.response.visualtenoneremark1 || "";
                tempInitialValues.commenttenoneremark1 = data.data.response.commenttenoneremark1 || "";
                tempInitialValues.typeofstatustenone1 = data.data.response.typeofstatustenone1 || "O";

                tempInitialValues.typeofcontrolstenone2 = data.data.response.typeofcontrolstenone2 || "OC";
                tempInitialValues.systemtestingtenoneremark2 = data.data.response.systemtestingtenoneremark2 || "";
                tempInitialValues.visualtenoneremark2 = data.data.response.visualtenoneremark2 || "";
                tempInitialValues.commenttenoneremark2 = data.data.response.commenttenoneremark2 || "";
                tempInitialValues.typeofstatustenone2 = data.data.response.typeofstatustenone2 || "O";

                tempInitialValues.typeofcontrolselevenone = data.data.response.typeofcontrolselevenone || "OC";
                tempInitialValues.systemtestingelevenoneremark = data.data.response.systemtestingelevenoneremark || "";
                tempInitialValues.visualelevenoneremark = data.data.response.visualelevenoneremark || "";
                tempInitialValues.commentelevenoneremark = data.data.response.commentelevenoneremark || "";
                tempInitialValues.typeofstatuselevenone = data.data.response.typeofstatuselevenone || "O";

                tempInitialValues.typeofcontrolselevenone1 = data.data.response.typeofcontrolselevenone1 || "OC";
                tempInitialValues.systemtestingelevenoneremark1 = data.data.response.systemtestingelevenoneremark1 || "";
                tempInitialValues.visualelevenoneremark1 = data.data.response.visualelevenoneremark1 || "";
                tempInitialValues.commentelevenoneremark1 = data.data.response.commentelevenoneremark1 || "";
                tempInitialValues.typeofstatuselevenone1 = data.data.response.typeofstatuselevenone1 || "O";

                tempInitialValues.typeofcontrolselevenone2 = data.data.response.typeofcontrolselevenone2 || "OC";
                tempInitialValues.systemtestingelevenoneremark2 = data.data.response.systemtestingelevenoneremark2 || "";
                tempInitialValues.visualelevenoneremark2 = data.data.response.visualelevenoneremark2 || "";
                tempInitialValues.commentelevenoneremark2 = data.data.response.commentelevenoneremark2 || "";
                tempInitialValues.typeofstatuselevenone2 = data.data.response.typeofstatuselevenone2 || "O";

                tempInitialValues.typeofcontrolselevenone3 = data.data.response.typeofcontrolselevenone3 || "OC";
                tempInitialValues.systemtestingelevenoneremark3 = data.data.response.systemtestingelevenoneremark3 || "";
                tempInitialValues.visualelevenoneremark3 = data.data.response.visualelevenoneremark3 || "";
                tempInitialValues.commentelevenoneremark3 = data.data.response.commentelevenoneremark3 || "";
                tempInitialValues.typeofstatuselevenone3 = data.data.response.typeofstatuselevenone3 || "O";

                tempInitialValues.typeofcontrolselevenone4 = data.data.response.typeofcontrolselevenone4 || "OC";
                tempInitialValues.systemtestingelevenoneremark4 = data.data.response.systemtestingelevenoneremark4 || "";
                tempInitialValues.visualelevenoneremark4 = data.data.response.visualelevenoneremark4 || "";
                tempInitialValues.commentelevenoneremark4 = data.data.response.commentelevenoneremark4 || "";
                tempInitialValues.typeofstatuselevenone4 = data.data.response.typeofstatuselevenone4 || "O";

                tempInitialValues.typeofcontrolselevenone5 = data.data.response.typeofcontrolselevenone5 || "OC";
                tempInitialValues.systemtestingelevenoneremark5 = data.data.response.systemtestingelevenoneremark5 || "";
                tempInitialValues.visualelevenoneremark5 = data.data.response.visualelevenoneremark5 || "";
                tempInitialValues.commentelevenoneremark5 = data.data.response.commentelevenoneremark5 || "";
                tempInitialValues.typeofstatuselevenone5 = data.data.response.typeofstatuselevenone5 || "O";

                tempInitialValues.typeofcontrolselevenone6 = data.data.response.typeofcontrolselevenone6 || "OC";
                tempInitialValues.systemtestingelevenoneremark6 = data.data.response.systemtestingelevenoneremark6 || "";
                tempInitialValues.visualelevenoneremark6 = data.data.response.visualelevenoneremark6 || "";
                tempInitialValues.commentelevenoneremark6 = data.data.response.commentelevenoneremark6 || "";
                tempInitialValues.typeofstatuselevenone6 = data.data.response.typeofstatuselevenone6 || "O";

                tempInitialValues.typeofcontrolseleventwo = data.data.response.typeofcontrolseleventwo || "OC";
                tempInitialValues.systemtestingeleventworemark = data.data.response.systemtestingeleventworemark || "";
                tempInitialValues.visualeleventworemark = data.data.response.visualeleventworemark || "";
                tempInitialValues.typeofstatuseleventwo = data.data.response.typeofstatuseleventwo || "O";
                tempInitialValues.commenteleventworemark = data.data.response.commenteleventworemark || "";

                tempInitialValues.typeofcontrolseleventwo1 = data.data.response.typeofcontrolseleventwo1 || "OC";
                tempInitialValues.systemtestingeleventworemark1 = data.data.response.systemtestingeleventworemark1 || "";
                tempInitialValues.visualeleventworemark1 = data.data.response.visualeleventworemark1 || "";
                tempInitialValues.typeofstatuseleventwo1 = data.data.response.typeofstatuseleventwo1 || "O";
                tempInitialValues.commenteleventworemark1 = data.data.response.commenteleventworemark1 || "";

                tempInitialValues.typeofcontrolseleventwo2 = data.data.response.typeofcontrolseleventwo2 || "OC";
                tempInitialValues.systemtestingeleventworemark2 = data.data.response.systemtestingeleventworemark2 || "";
                tempInitialValues.visualeleventworemark2 = data.data.response.visualeleventworemark2 || "";
                tempInitialValues.typeofstatuseleventwo2 = data.data.response.typeofstatuseleventwo2 || "O";
                tempInitialValues.commenteleventworemark2 = data.data.response.commenteleventworemark2 || "";

                tempInitialValues.typeofcontrolseleventwo3 = data.data.response.typeofcontrolseleventwo3 || "OC";
                tempInitialValues.systemtestingeleventworemark3 = data.data.response.systemtestingeleventworemark3 || "";
                tempInitialValues.visualeleventworemark3 = data.data.response.visualeleventworemark3 || "";
                tempInitialValues.typeofstatuseleventwo3 = data.data.response.typeofstatuseleventwo3 || "O";
                tempInitialValues.commenteleventworemark3 = data.data.response.commenteleventworemark3 || "";

                tempInitialValues.typeofcontrolseleventwo4 = data.data.response.typeofcontrolseleventwo4 || "OC";
                tempInitialValues.systemtestingeleventworemark4 = data.data.response.systemtestingeleventworemark4 || "";
                tempInitialValues.visualeleventworemark4 = data.data.response.visualeleventworemark4 || "";
                tempInitialValues.typeofstatuseleventwo4 = data.data.response.typeofstatuseleventwo4 || "O";
                tempInitialValues.commenteleventworemark4 = data.data.response.commenteleventworemark4 || "";

                tempInitialValues.typeofcontrolseleventwo5 = data.data.response.typeofcontrolseleventwo5 || "OC";
                tempInitialValues.systemtestingeleventworemark5 = data.data.response.systemtestingeleventworemark5 || "";
                tempInitialValues.visualeleventworemark5 = data.data.response.visualeleventworemark5 || "";
                tempInitialValues.typeofstatuseleventwo5 = data.data.response.typeofstatuseleventwo5 || "O";
                tempInitialValues.commenteleventworemark5 = data.data.response.commenteleventworemark5 || "";

                tempInitialValues.typeofcontrolseleventwo6 = data.data.response.typeofcontrolseleventwo6 || "OC";
                tempInitialValues.systemtestingeleventworemark6 = data.data.response.systemtestingeleventworemark6 || "";
                tempInitialValues.visualeleventworemark6 = data.data.response.visualeleventworemark6 || "";
                tempInitialValues.typeofstatuseleventwo6 = data.data.response.typeofstatuseleventwo6 || "O";
                tempInitialValues.commenteleventworemark6 = data.data.response.commenteleventworemark6 || "";

                tempInitialValues.typeofcontrolseleventwo7 = data.data.response.typeofcontrolseleventwo7 || "OC";
                tempInitialValues.systemtestingeleventworemark7 = data.data.response.systemtestingeleventworemark7 || "";
                tempInitialValues.visualeleventworemark7 = data.data.response.visualeleventworemark7 || "";
                tempInitialValues.typeofstatuseleventwo7 = data.data.response.typeofstatuseleventwo7 || "O";
                tempInitialValues.commenteleventworemark7 = data.data.response.commenteleventworemark7 || "";

                tempInitialValues.typeofcontrolseleventwo8 = data.data.response.typeofcontrolseleventwo8 || "OC";
                tempInitialValues.systemtestingeleventworemark8 = data.data.response.systemtestingeleventworemark8 || "";
                tempInitialValues.visualeleventworemark8 = data.data.response.visualeleventworemark8 || "";
                tempInitialValues.typeofstatuseleventwo8 = data.data.response.typeofstatuseleventwo8 || "O";
                tempInitialValues.commenteleventworemark8 = data.data.response.commenteleventworemark8 || "";

                tempInitialValues.typeofcontrolseleventwo9 = data.data.response.typeofcontrolseleventwo9 || "OC";
                tempInitialValues.systemtestingeleventworemark9 = data.data.response.systemtestingeleventworemark9 || "";
                tempInitialValues.visualeleventworemark9 = data.data.response.visualeleventworemark9 || "";
                tempInitialValues.typeofstatuseleventwo9 = data.data.response.typeofstatuseleventwo9 || "O";
                tempInitialValues.commenteleventworemark9 = data.data.response.commenteleventworemark9 || "";

                tempInitialValues.typeofcontrolstwelveone = data.data.response.typeofcontrolstwelveone || "OC";
                tempInitialValues.systemtestingtwelveoneremark = data.data.response.systemtestingtwelveoneremark || "";
                tempInitialValues.visualtwelveoneremark = data.data.response.visualtwelveoneremark || "";
                tempInitialValues.typeofstatustwelveone = data.data.response.typeofstatustwelveone || "O";
                tempInitialValues.commenttwelveoneremark = data.data.response.commenttwelveoneremark || "";

                tempInitialValues.typeofcontrolstwelveone1 = data.data.response.typeofcontrolstwelveone1 || "OC";
                tempInitialValues.systemtestingtwelveoneremark1 = data.data.response.systemtestingtwelveoneremark1 || "";
                tempInitialValues.visualtwelveoneremark1 = data.data.response.visualtwelveoneremark1 || "";
                tempInitialValues.typeofstatustwelveone1 = data.data.response.typeofstatustwelveone1 || "O";
                tempInitialValues.commenttwelveoneremark1 = data.data.response.commenttwelveoneremark1 || "";

                tempInitialValues.typeofcontrolstwelveone2 = data.data.response.typeofcontrolstwelveone2 || "OC";
                tempInitialValues.systemtestingtwelveoneremark2 = data.data.response.systemtestingtwelveoneremark2 || "";
                tempInitialValues.visualtwelveoneremark2 = data.data.response.visualtwelveoneremark2 || "";
                tempInitialValues.typeofstatustwelveone2 = data.data.response.typeofstatustwelveone2 || "O";
                tempInitialValues.commenttwelveoneremark2 = data.data.response.commenttwelveoneremark2 || "";

                tempInitialValues.typeofcontrolstwelveone3 = data.data.response.typeofcontrolstwelveone3 || "OC";
                tempInitialValues.systemtestingtwelveoneremark3 = data.data.response.systemtestingtwelveoneremark3 || "";
                tempInitialValues.visualtwelveoneremark3 = data.data.response.visualtwelveoneremark3 || "";
                tempInitialValues.typeofstatustwelveone3 = data.data.response.typeofstatustwelveone3 || "O";
                tempInitialValues.commenttwelveoneremark3 = data.data.response.commenttwelveoneremark3 || "";

                tempInitialValues.typeofcontrolstwelveone5 = data.data.response.typeofcontrolstwelveone5 || "OC";
                tempInitialValues.systemtestingtwelveoneremark5 = data.data.response.systemtestingtwelveoneremark5 || "";
                tempInitialValues.visualtwelveoneremark5 = data.data.response.visualtwelveoneremark5 || "";
                tempInitialValues.typeofstatustwelveone5 = data.data.response.typeofstatustwelveone5 || "O";
                tempInitialValues.commenttwelveoneremark5 = data.data.response.commenttwelveoneremark5 || "";

                tempInitialValues.typeofcontrolstwelvetwo = data.data.response.typeofcontrolstwelvetwo || "OC";
                tempInitialValues.systemtestingtwelvetworemark = data.data.response.systemtestingtwelvetworemark || "";
                tempInitialValues.visualtwelvetworemark = data.data.response.visualtwelvetworemark || "";
                tempInitialValues.typeofstatustwelvetwo = data.data.response.typeofstatustwelvetwo || "O";
                tempInitialValues.commenttwelvetworemark = data.data.response.commenttwelvetworemark || "";

                tempInitialValues.typeofcontrolstwelvetwo1 = data.data.response.typeofcontrolstwelvetwo1 || "OC";
                tempInitialValues.systemtestingtwelvetworemark1 = data.data.response.systemtestingtwelvetworemark1 || "";
                tempInitialValues.visualtwelvetworemark1 = data.data.response.visualtwelvetworemark1 || "";
                tempInitialValues.typeofstatustwelvetwo1 = data.data.response.typeofstatustwelvetwo1 || "O";
                tempInitialValues.commenttwelvetworemark1 = data.data.response.commenttwelvetworemark1 || "";

                tempInitialValues.typeofcontrolstwelvethree = data.data.response.typeofcontrolstwelvethree || "OC";
                tempInitialValues.systemtestingtwelvethreeremark = data.data.response.systemtestingtwelvethreeremark || "";
                tempInitialValues.visualtwelvethreeremark = data.data.response.visualtwelvethreeremark || "";
                tempInitialValues.typeofstatustwelvethree = data.data.response.typeofstatustwelvethree || "O";
                tempInitialValues.commenttwelvethreeremark = data.data.response.commenttwelvethreeremark || "";

                tempInitialValues.typeofcontrolstwelvethree1 = data.data.response.typeofcontrolstwelvethree1 || "OC";
                tempInitialValues.systemtestingtwelvethreeremark1 = data.data.response.systemtestingtwelvethreeremark1 || "";
                tempInitialValues.visualtwelvethreeremark1 = data.data.response.visualtwelvethreeremark1 || "";
                tempInitialValues.typeofstatustwelvethree1 = data.data.response.typeofstatustwelvethree1 || "O";
                tempInitialValues.commenttwelvethreeremark1 = data.data.response.commenttwelvethreeremark1 || "";

                tempInitialValues.typeofcontrolstwelvefour = data.data.response.typeofcontrolstwelvefour || "OC";
                tempInitialValues.systemtestingtwelvefourremark = data.data.response.systemtestingtwelvefourremark || "";
                tempInitialValues.visualtwelvefourremark = data.data.response.visualtwelvefourremark || "";
                tempInitialValues.typeofstatustwelvefour = data.data.response.typeofstatustwelvefour || "O";
                tempInitialValues.commenttwelvefourremark = data.data.response.commenttwelvefourremark || "";

                tempInitialValues.typeofcontrolstwelvefour1 = data.data.response.typeofcontrolstwelvefour1 || "OC";
                tempInitialValues.systemtestingtwelvefourremark1 = data.data.response.systemtestingtwelvefourremark1 || "";
                tempInitialValues.visualtwelvefourremark1 = data.data.response.visualtwelvefourremark1 || "";
                tempInitialValues.typeofstatustwelvefour1 = data.data.response.typeofstatustwelvefour1 || "O";
                tempInitialValues.commenttwelvefourremark1 = data.data.response.commenttwelvefourremark1 || "";

                tempInitialValues.typeofcontrolstwelvefour2 = data.data.response.typeofcontrolstwelvefour2 || "OC";
                tempInitialValues.systemtestingtwelvefourremark2 = data.data.response.systemtestingtwelvefourremark2 || "";
                tempInitialValues.visualtwelvefourremark2 = data.data.response.visualtwelvefourremark2 || "";
                tempInitialValues.typeofstatustwelvefour2 = data.data.response.typeofstatustwelvefour2 || "O";
                tempInitialValues.commenttwelvefourremark2 = data.data.response.commenttwelvefourremark2 || "";

                tempInitialValues.typeofcontrolstwelvefour3 = data.data.response.typeofcontrolstwelvefour3 || "OC";
                tempInitialValues.systemtestingtwelvefourremark3 = data.data.response.systemtestingtwelvefourremark3 || "";
                tempInitialValues.visualtwelvefourremark3 = data.data.response.visualtwelvefourremark3 || "";
                tempInitialValues.typeofstatustwelvefour3 = data.data.response.typeofstatustwelvefour3 || "O";
                tempInitialValues.commenttwelvefourremark3 = data.data.response.commenttwelvefourremark3 || "";

                tempInitialValues.typeofcontrolstwelvefour4 = data.data.response.typeofcontrolstwelvefour4 || "OC";
                tempInitialValues.systemtestingtwelvefourremark4 = data.data.response.systemtestingtwelvefourremark4 || "";
                tempInitialValues.visualtwelvefourremark4 = data.data.response.visualtwelvefourremark4 || "";
                tempInitialValues.typeofstatustwelvefour4 = data.data.response.typeofstatustwelvefour4 || "O";
                tempInitialValues.commenttwelvefourremark4 = data.data.response.commenttwelvefourremark4 || "";

                tempInitialValues.typeofcontrolstwelvefive = data.data.response.typeofcontrolstwelvefive || "OC";
                tempInitialValues.systemtestingtwelvefiveremark = data.data.response.systemtestingtwelvefiveremark || "";
                tempInitialValues.visualtwelvefiveremark = data.data.response.visualtwelvefiveremark || "";
                tempInitialValues.typeofstatustwelvefive = data.data.response.typeofstatustwelvefive || "O";
                tempInitialValues.commenttwelvefiveremark = data.data.response.commenttwelvefiveremark || "";

                tempInitialValues.typeofcontrolstwelvefive1 = data.data.response.typeofcontrolstwelvefive1 || "OC";
                tempInitialValues.systemtestingtwelvefiveremark1 = data.data.response.systemtestingtwelvefiveremark1 || "";
                tempInitialValues.visualtwelvefiveremark1 = data.data.response.visualtwelvefiveremark1 || "";
                tempInitialValues.typeofstatustwelvefive1 = data.data.response.typeofstatustwelvefive1 || "O";
                tempInitialValues.commenttwelvefiveremark1 = data.data.response.commenttwelvefiveremark1 || "";

                tempInitialValues.typeofcontrolstwelvesix = data.data.response.typeofcontrolstwelvesix || "OC";
                tempInitialValues.systemtestingtwelvesixremark = data.data.response.systemtestingtwelvesixremark || "";
                tempInitialValues.visualtwelvesixremark = data.data.response.visualtwelvesixremark || "";
                tempInitialValues.typeofstatustwelvesix = data.data.response.typeofstatustwelvesix || "O";
                tempInitialValues.commenttwelvesixremark = data.data.response.commenttwelvesixremark || "";

                tempInitialValues.typeofcontrolstwelvesix1 = data.data.response.typeofcontrolstwelvesix1 || "OC";
                tempInitialValues.systemtestingtwelvesixremark1 = data.data.response.systemtestingtwelvesixremark1 || "";
                tempInitialValues.visualtwelvesixremark1 = data.data.response.visualtwelvesixremark1 || "";
                tempInitialValues.typeofstatustwelvesix1 = data.data.response.typeofstatustwelvesix1 || "O";
                tempInitialValues.commenttwelvesixremark1 = data.data.response.commenttwelvesixremark1 || "";

                tempInitialValues.typeofcontrolstwelvesix2 = data.data.response.typeofcontrolstwelvesix2 || "OC";
                tempInitialValues.systemtestingtwelvesixremark2 = data.data.response.systemtestingtwelvesixremark2 || "";
                tempInitialValues.visualtwelvesixremark2 = data.data.response.visualtwelvesixremark2 || "";
                tempInitialValues.typeofstatustwelvesix2 = data.data.response.typeofstatustwelvesix2 || "O";
                tempInitialValues.commenttwelvesixremark2 = data.data.response.commenttwelvesixremark2 || "";

                tempInitialValues.typeofcontrolstwelveseven = data.data.response.typeofcontrolstwelveseven || "OC";
                tempInitialValues.systemtestingtwelvesevenremark = data.data.response.systemtestingtwelvesevenremark || "";
                tempInitialValues.visualtwelvesevenremark = data.data.response.visualtwelvesevenremark || "";
                tempInitialValues.typeofstatustwelveseven = data.data.response.typeofstatustwelveseven || "O";
                tempInitialValues.commenttwelvesevenremark = data.data.response.commenttwelvesevenremark || "";

                tempInitialValues.typeofcontrolstwelveseven1 = data.data.response.typeofcontrolstwelveseven1 || "OC";
                tempInitialValues.systemtestingtwelvesevenremark1 = data.data.response.systemtestingtwelvesevenremark1 || "";
                tempInitialValues.visualtwelvesevenremark1 = data.data.response.visualtwelvesevenremark1 || "";
                tempInitialValues.typeofstatustwelveseven1 = data.data.response.typeofstatustwelveseven1 || "O";
                tempInitialValues.commenttwelvesevenremark1 = data.data.response.commenttwelvesevenremark1 || "";

                tempInitialValues.typeofcontrolsthirteenone = data.data.response.typeofcontrolsthirteenone || "OC";
                tempInitialValues.systemtestingthirteenoneremark = data.data.response.systemtestingthirteenoneremark || "";
                tempInitialValues.visualthirteenoneremark = data.data.response.visualthirteenoneremark || "";
                tempInitialValues.typeofstatusthirteenone = data.data.response.typeofstatusthirteenone || "O";
                tempInitialValues.commentthirteenoneremark = data.data.response.commentthirteenoneremark || "";

                tempInitialValues.typeofcontrolsthirteenone1 = data.data.response.typeofcontrolsthirteenone1 || "OC";
                tempInitialValues.systemtestingthirteenoneremark1 = data.data.response.systemtestingthirteenoneremark1 || "";
                tempInitialValues.visualthirteenoneremark1 = data.data.response.visualthirteenoneremark1 || "";
                tempInitialValues.typeofstatusthirteenone1 = data.data.response.typeofstatusthirteenone1 || "O";
                tempInitialValues.commentthirteenoneremark1 = data.data.response.commentthirteenoneremark1 || "";

                tempInitialValues.typeofcontrolsthirteenone2 = data.data.response.typeofcontrolsthirteenone2 || "OC";
                tempInitialValues.systemtestingthirteenoneremark2 = data.data.response.systemtestingthirteenoneremark2 || "";
                tempInitialValues.visualthirteenoneremark2 = data.data.response.visualthirteenoneremark2 || "";
                tempInitialValues.typeofstatusthirteenone2 = data.data.response.typeofstatusthirteenone2 || "O";
                tempInitialValues.commentthirteenoneremark2 = data.data.response.commentthirteenoneremark2 || "";

                tempInitialValues.typeofcontrolsthirteenone3 = data.data.response.typeofcontrolsthirteenone3 || "OC";
                tempInitialValues.systemtestingthirteenoneremark3 = data.data.response.systemtestingthirteenoneremark3 || "";
                tempInitialValues.visualthirteenoneremark3 = data.data.response.visualthirteenoneremark3 || "";
                tempInitialValues.typeofstatusthirteenone3 = data.data.response.typeofstatusthirteenone3 || "O";
                tempInitialValues.commentthirteenoneremark3 = data.data.response.commentthirteenoneremark3 || "";

                tempInitialValues.typeofcontrolsthirteentwo = data.data.response.typeofcontrolsthirteentwo || "OC";
                tempInitialValues.systemtestingthirteentworemark = data.data.response.systemtestingthirteentworemark || "";
                tempInitialValues.visualthirteentworemark = data.data.response.visualthirteentworemark || "";
                tempInitialValues.typeofstatusthirteentwo = data.data.response.typeofstatusthirteentwo || "O";
                tempInitialValues.commentthirteentworemark = data.data.response.commentthirteentworemark || "";

                tempInitialValues.typeofcontrolsthirteentwo1 = data.data.response.typeofcontrolsthirteentwo1 || "OC";
                tempInitialValues.systemtestingthirteentworemark1 = data.data.response.systemtestingthirteentworemark1 || "";
                tempInitialValues.visualthirteentworemark1 = data.data.response.visualthirteentworemark1 || "";
                tempInitialValues.typeofstatusthirteentwo1 = data.data.response.typeofstatusthirteentwo1 || "O";
                tempInitialValues.commentthirteentworemark1 = data.data.response.commentthirteentworemark1 || "";

                tempInitialValues.typeofcontrolsthirteentwo2 = data.data.response.typeofcontrolsthirteentwo2 || "OC";
                tempInitialValues.systemtestingthirteentworemark2 = data.data.response.systemtestingthirteentworemark2 || "";
                tempInitialValues.visualthirteentworemark2 = data.data.response.visualthirteentworemark2 || "";
                tempInitialValues.typeofstatusthirteentwo2 = data.data.response.typeofstatusthirteentwo2 || "O";
                tempInitialValues.commentthirteentworemark2 = data.data.response.commentthirteentworemark2 || "";

                tempInitialValues.typeofcontrolsthirteentwo3 = data.data.response.typeofcontrolsthirteentwo3 || "OC";
                tempInitialValues.systemtestingthirteentworemark3 = data.data.response.systemtestingthirteentworemark3 || "";
                tempInitialValues.visualthirteentworemark3 = data.data.response.visualthirteentworemark3 || "";
                tempInitialValues.typeofstatusthirteentwo3 = data.data.response.typeofstatusthirteentwo3 || "O";
                tempInitialValues.commentthirteentworemark3 = data.data.response.commentthirteentworemark3 || "";

                tempInitialValues.typeofcontrolsthirteentwo4 = data.data.response.typeofcontrolsthirteentwo4 || "OC";
                tempInitialValues.systemtestingthirteentworemark4 = data.data.response.systemtestingthirteentworemark4 || "";
                tempInitialValues.visualthirteentworemark4 = data.data.response.visualthirteentworemark4 || "";
                tempInitialValues.typeofstatusthirteentwo4 = data.data.response.typeofstatusthirteentwo4 || "O";
                tempInitialValues.commentthirteentworemark4 = data.data.response.commentthirteentworemark4 || "";

                tempInitialValues.typeofcontrolsfourteenone = data.data.response.typeofcontrolsfourteenone || "OC";
                tempInitialValues.systemtestingfourteenoneremark = data.data.response.systemtestingfourteenoneremark || "";
                tempInitialValues.visualfourteenoneremark = data.data.response.visualfourteenoneremark || "";
                tempInitialValues.typeofstatusfourteenone = data.data.response.typeofstatusfourteenone || "O";
                tempInitialValues.commentfourteenoneremark = data.data.response.commentfourteenoneremark || "";

                tempInitialValues.typeofcontrolsfourteenone1 = data.data.response.typeofcontrolsfourteenone1 || "OC";
                tempInitialValues.systemtestingfourteenoneremark1 = data.data.response.systemtestingfourteenoneremark1 || "";
                tempInitialValues.visualfourteenoneremark1 = data.data.response.visualfourteenoneremark1 || "";
                tempInitialValues.typeofstatusfourteenone1 = data.data.response.typeofstatusfourteenone1 || "O";
                tempInitialValues.commentfourteenoneremark1 = data.data.response.commentfourteenoneremark1 || "";

                tempInitialValues.typeofcontrolsfourteenone2 = data.data.response.typeofcontrolsfourteenone2 || "OC";
                tempInitialValues.systemtestingfourteenoneremark2 = data.data.response.systemtestingfourteenoneremark2 || "";
                tempInitialValues.visualfourteenoneremark2 = data.data.response.visualfourteenoneremark2 || "";
                tempInitialValues.typeofstatusfourteenone2 = data.data.response.typeofstatusfourteenone2 || "O";
                tempInitialValues.commentfourteenoneremark2 = data.data.response.commentfourteenoneremark2 || "";

                tempInitialValues.typeofcontrolsfourteenone3 = data.data.response.typeofcontrolsfourteenone3 || "OC";
                tempInitialValues.systemtestingfourteenoneremark3 = data.data.response.systemtestingfourteenoneremark3 || "";
                tempInitialValues.visualfourteenoneremark3 = data.data.response.visualfourteenoneremark3 || "";
                tempInitialValues.typeofstatusfourteenone3 = data.data.response.typeofstatusfourteenone3 || "O";
                tempInitialValues.commentfourteenoneremark3 = data.data.response.commentfourteenoneremark3 || "";

                tempInitialValues.typeofcontrolsfourteentwo = data.data.response.typeofcontrolsfourteentwo || "OC";
                tempInitialValues.systemtestingfourteentworemark = data.data.response.systemtestingfourteentworemark || "";
                tempInitialValues.visualfourteentworemark = data.data.response.visualfourteentworemark || "";
                tempInitialValues.typeofstatusfourteentwo = data.data.response.typeofstatusfourteentwo || "O";
                tempInitialValues.commentfourteentworemark = data.data.response.commentfourteentworemark || "";

                tempInitialValues.typeofcontrolsfourteentwo1 = data.data.response.typeofcontrolsfourteentwo1 || "OC";
                tempInitialValues.systemtestingfourteentworemark1 = data.data.response.systemtestingfourteentworemark1 || "";
                tempInitialValues.visualfourteentworemark1 = data.data.response.visualfourteentworemark1 || "";
                tempInitialValues.typeofstatusfourteentwo1 = data.data.response.typeofstatusfourteentwo1 || "O";
                tempInitialValues.commentfourteentworemark1 = data.data.response.commentfourteentworemark1 || "";

                tempInitialValues.typeofcontrolsfourteentwo2 = data.data.response.typeofcontrolsfourteentwo2 || "OC";
                tempInitialValues.systemtestingfourteentworemark2 = data.data.response.systemtestingfourteentworemark2 || "";
                tempInitialValues.visualfourteentworemark2 = data.data.response.visualfourteentworemark2 || "";
                tempInitialValues.typeofstatusfourteentwo2 = data.data.response.typeofstatusfourteentwo2 || "O";
                tempInitialValues.commentfourteentworemark2 = data.data.response.commentfourteentworemark2 || "";

                tempInitialValues.typeofcontrolsfourteentwo3 = data.data.response.typeofcontrolsfourteentwo3 || "OC";
                tempInitialValues.systemtestingfourteentworemark3 = data.data.response.systemtestingfourteentworemark3 || "";
                tempInitialValues.visualfourteentworemark3 = data.data.response.visualfourteentworemark3 || "";
                tempInitialValues.typeofstatusfourteentwo3 = data.data.response.typeofstatusfourteentwo3 || "O";
                tempInitialValues.commentfourteentworemark3 = data.data.response.commentfourteentworemark3 || "";

                tempInitialValues.typeofcontrolsfourteentwo4 = data.data.response.typeofcontrolsfourteentwo4 || "OC";
                tempInitialValues.systemtestingfourteentworemark4 = data.data.response.systemtestingfourteentworemark4 || "";
                tempInitialValues.visualfourteentworemark4 = data.data.response.visualfourteentworemark4 || "";
                tempInitialValues.typeofstatusfourteentwo4 = data.data.response.typeofstatusfourteentwo4 || "O";
                tempInitialValues.commentfourteentworemark4 = data.data.response.commentfourteentworemark4 || "";

                tempInitialValues.typeofcontrolsfourteentwo5 = data.data.response.typeofcontrolsfourteentwo5 || "OC";
                tempInitialValues.systemtestingfourteentworemark5 = data.data.response.systemtestingfourteentworemark5 || "";
                tempInitialValues.visualfourteentworemark5 = data.data.response.visualfourteentworemark5 || "";
                tempInitialValues.typeofstatusfourteentwo5 = data.data.response.typeofstatusfourteentwo5 || "O";
                tempInitialValues.commentfourteentworemark5 = data.data.response.commentfourteentworemark5 || "";

                tempInitialValues.typeofcontrolsfourteentwo6 = data.data.response.typeofcontrolsfourteentwo6 || "OC";
                tempInitialValues.systemtestingfourteentworemark6 = data.data.response.systemtestingfourteentworemark6 || "";
                tempInitialValues.visualfourteentworemark6 = data.data.response.visualfourteentworemark6 || "";
                tempInitialValues.typeofstatusfourteentwo6 = data.data.response.typeofstatusfourteentwo6 || "O";
                tempInitialValues.commentfourteentworemark6 = data.data.response.commentfourteentworemark6 || "";

                tempInitialValues.typeofcontrolsfourteentwo7 = data.data.response.typeofcontrolsfourteentwo7 || "OC";
                tempInitialValues.systemtestingfourteentworemark7 = data.data.response.systemtestingfourteentworemark7 || "";
                tempInitialValues.visualfourteentworemark7 = data.data.response.visualfourteentworemark7 || "";
                tempInitialValues.typeofstatusfourteentwo7 = data.data.response.typeofstatusfourteentwo7 || "O";
                tempInitialValues.commentfourteentworemark7 = data.data.response.commentfourteentworemark7 || "";

                tempInitialValues.typeofcontrolsfourteentwo8 = data.data.response.typeofcontrolsfourteentwo8 || "OC";
                tempInitialValues.systemtestingfourteentworemark8 = data.data.response.systemtestingfourteentworemark8 || "";
                tempInitialValues.visualfourteentworemark8 = data.data.response.visualfourteentworemark8 || "";
                tempInitialValues.typeofstatusfourteentwo8 = data.data.response.typeofstatusfourteentwo8 || "O";
                tempInitialValues.commentfourteentworemark8 = data.data.response.commentfourteentworemark8 || "";

                tempInitialValues.typeofcontrolsfourteentwo9 = data.data.response.typeofcontrolsfourteentwo9 || "OC";
                tempInitialValues.systemtestingfourteentworemark9 = data.data.response.systemtestingfourteentworemark9 || "";
                tempInitialValues.visualfourteentworemark9 = data.data.response.visualfourteentworemark9 || "";
                tempInitialValues.typeofstatusfourteentwo9 = data.data.response.typeofstatusfourteentwo9 || "O";
                tempInitialValues.commentfourteentworemark9 = data.data.response.commentfourteentworemark9 || "";

                tempInitialValues.typeofcontrolsfourteenthree = data.data.response.typeofcontrolsfourteenthree || "OC";
                tempInitialValues.systemtestingfourteenthreeremark = data.data.response.systemtestingfourteenthreeremark || "";
                tempInitialValues.visualfourteenthreeremark = data.data.response.visualfourteenthreeremark || "";
                tempInitialValues.typeofstatusfourteenthree = data.data.response.typeofstatusfourteenthree || "O";
                tempInitialValues.commentfourteenthreeremark = data.data.response.commentfourteenthreeremark || "";

                tempInitialValues.typeofcontrolsfourteenthree1 = data.data.response.typeofcontrolsfourteenthree1 || "OC";
                tempInitialValues.systemtestingfourteenthreeremark1 = data.data.response.systemtestingfourteenthreeremark1 || "";
                tempInitialValues.visualfourteenthreeremark1 = data.data.response.visualfourteenthreeremark1 || "";
                tempInitialValues.typeofstatusfourteenthree1 = data.data.response.typeofstatusfourteenthree1 || "O";
                tempInitialValues.commentfourteenthreeremark1 = data.data.response.commentfourteenthreeremark1 || "";

                tempInitialValues.typeofcontrolsfifteenone = data.data.response.typeofcontrolsfifteenone || "OC";
                tempInitialValues.systemtestingfifteenoneremark = data.data.response.systemtestingfifteenoneremark || "";
                tempInitialValues.visualfifteenoneremark = data.data.response.visualfifteenoneremark || "";
                tempInitialValues.typeofstatusfifteenone = data.data.response.typeofstatusfifteenone || "O";
                tempInitialValues.commentfifteenoneremark = data.data.response.commentfifteenoneremark || "";

                tempInitialValues.typeofcontrolsfifteenone1 = data.data.response.typeofcontrolsfifteenone1 || "OC";
                tempInitialValues.systemtestingfifteenoneremark1 = data.data.response.systemtestingfifteenoneremark1 || "";
                tempInitialValues.visualfifteenoneremark1 = data.data.response.visualfifteenoneremark1 || "";
                tempInitialValues.typeofstatusfifteenone1 = data.data.response.typeofstatusfifteenone1 || "O";
                tempInitialValues.commentfifteenoneremark1 = data.data.response.commentfifteenoneremark1 || "";

                tempInitialValues.typeofcontrolsfifteenone2 = data.data.response.typeofcontrolsfifteenone2 || "OC";
                tempInitialValues.systemtestingfifteenoneremark2 = data.data.response.systemtestingfifteenoneremark2 || "";
                tempInitialValues.visualfifteenoneremark2 = data.data.response.visualfifteenoneremark2 || "";
                tempInitialValues.typeofstatusfifteenone2 = data.data.response.typeofstatusfifteenone2 || "O";
                tempInitialValues.commentfifteenoneremark2 = data.data.response.commentfifteenoneremark2 || "";

                tempInitialValues.typeofcontrolsfifteenone3 = data.data.response.typeofcontrolsfifteenone3 || "OC";
                tempInitialValues.systemtestingfifteenoneremark3 = data.data.response.systemtestingfifteenoneremark3 || "";
                tempInitialValues.visualfifteenoneremark3 = data.data.response.visualfifteenoneremark3 || "";
                tempInitialValues.typeofstatusfifteenone3 = data.data.response.typeofstatusfifteenone3 || "O";
                tempInitialValues.commentfifteenoneremark3 = data.data.response.commentfifteenoneremark3 || "";

                tempInitialValues.typeofcontrolsfifteentwo = data.data.response.typeofcontrolsfifteentwo || "OC";
                tempInitialValues.systemtestingfifteentworemark = data.data.response.systemtestingfifteentworemark || "";
                tempInitialValues.visualfifteentworemark = data.data.response.visualfifteentworemark || "";
                tempInitialValues.typeofstatusfifteentwo = data.data.response.typeofstatusfifteentwo || "O";
                tempInitialValues.commentfifteentworemark = data.data.response.commentfifteentworemark || "";

                tempInitialValues.typeofcontrolsfifteentwo1 = data.data.response.typeofcontrolsfifteentwo1 || "OC";
                tempInitialValues.systemtestingfifteentworemark1 = data.data.response.systemtestingfifteentworemark1 || "";
                tempInitialValues.visualfifteentworemark1 = data.data.response.visualfifteentworemark1 || "";
                tempInitialValues.typeofstatusfifteentwo1 = data.data.response.typeofstatusfifteentwo1 || "O";
                tempInitialValues.commentfifteentworemark1 = data.data.response.commentfifteentworemark1 || "";

                tempInitialValues.typeofcontrolsfifteentwo2 = data.data.response.typeofcontrolsfifteentwo2 || "OC";
                tempInitialValues.systemtestingfifteentworemark2 = data.data.response.systemtestingfifteentworemark2 || "";
                tempInitialValues.visualfifteentworemark2 = data.data.response.visualfifteentworemark2 || "";
                tempInitialValues.typeofstatusfifteentwo2 = data.data.response.typeofstatusfifteentwo2 || "O";
                tempInitialValues.commentfifteentworemark2 = data.data.response.commentfifteentworemark2 || "";

                tempInitialValues.typeofcontrolssixteenone = data.data.response.typeofcontrolssixteenone || "OC";
                tempInitialValues.systemtestingsixteenoneremark = data.data.response.systemtestingsixteenoneremark || "";
                tempInitialValues.visualsixteenoneremark = data.data.response.visualsixteenoneremark || "";
                tempInitialValues.typeofstatussixteenone = data.data.response.typeofstatussixteenone || "O";
                tempInitialValues.commentsixteenoneremark = data.data.response.commentsixteenoneremark || "";

                tempInitialValues.typeofcontrolssixteenone1 = data.data.response.typeofcontrolssixteenone1 || "OC";
                tempInitialValues.systemtestingsixteenoneremark1 = data.data.response.systemtestingsixteenoneremark1 || "";
                tempInitialValues.visualsixteenoneremark1 = data.data.response.visualsixteenoneremark1 || "";
                tempInitialValues.typeofstatussixteenone1 = data.data.response.typeofstatussixteenone1 || "O";
                tempInitialValues.commentsixteenoneremark1 = data.data.response.commentsixteenoneremark1 || "";

                tempInitialValues.typeofcontrolssixteenone2 = data.data.response.typeofcontrolssixteenone2 || "OC";
                tempInitialValues.systemtestingsixteenoneremark2 = data.data.response.systemtestingsixteenoneremark2 || "";
                tempInitialValues.visualsixteenoneremark2 = data.data.response.visualsixteenoneremark2 || "";
                tempInitialValues.typeofstatussixteenone2 = data.data.response.typeofstatussixteenone2 || "O";
                tempInitialValues.commentsixteenoneremark2 = data.data.response.commentsixteenoneremark2 || "";

                tempInitialValues.typeofcontrolssixteenone3 = data.data.response.typeofcontrolssixteenone3 || "OC";
                tempInitialValues.systemtestingsixteenoneremark3 = data.data.response.systemtestingsixteenoneremark3 || "";
                tempInitialValues.visualsixteenoneremark3 = data.data.response.visualsixteenoneremark3 || "";
                tempInitialValues.typeofstatussixteenone3 = data.data.response.typeofstatussixteenone3 || "O";
                tempInitialValues.commentsixteenoneremark3 = data.data.response.commentsixteenoneremark3 || "";

                tempInitialValues.typeofcontrolssixteenone4 = data.data.response.typeofcontrolssixteenone4 || "OC";
                tempInitialValues.systemtestingsixteenoneremark4 = data.data.response.systemtestingsixteenoneremark4 || "";
                tempInitialValues.visualsixteenoneremark4 = data.data.response.visualsixteenoneremark4 || "";
                tempInitialValues.typeofstatussixteenone4 = data.data.response.typeofstatussixteenone4 || "O";
                tempInitialValues.commentsixteenoneremark4 = data.data.response.commentsixteenoneremark4 || "";

                tempInitialValues.typeofcontrolssixteenone5 = data.data.response.typeofcontrolssixteenone5 || "OC";
                tempInitialValues.systemtestingsixteenoneremark5 = data.data.response.systemtestingsixteenoneremark5 || "";
                tempInitialValues.visualsixteenoneremark5 = data.data.response.visualsixteenoneremark5 || "";
                tempInitialValues.typeofstatussixteenone5 = data.data.response.typeofstatussixteenone5 || "O";
                tempInitialValues.commentsixteenoneremark5 = data.data.response.commentsixteenoneremark5 || "";

                tempInitialValues.typeofcontrolssixteenone6 = data.data.response.typeofcontrolssixteenone6 || "OC";
                tempInitialValues.systemtestingsixteenoneremark6 = data.data.response.systemtestingsixteenoneremark6 || "";
                tempInitialValues.visualsixteenoneremark6 = data.data.response.visualsixteenoneremark6 || "";
                tempInitialValues.typeofstatussixteenone6 = data.data.response.typeofstatussixteenone6 || "O";
                tempInitialValues.commentsixteenoneremark6 = data.data.response.commentsixteenoneremark6 || "";

                tempInitialValues.typeofcontrolssixteenone7 = data.data.response.typeofcontrolssixteenone7 || "OC";
                tempInitialValues.systemtestingsixteenoneremark7 = data.data.response.systemtestingsixteenoneremark7 || "";
                tempInitialValues.visualsixteenoneremark7 = data.data.response.visualsixteenoneremark7 || "";
                tempInitialValues.typeofstatussixteenone7 = data.data.response.typeofstatussixteenone7 || "O";
                tempInitialValues.commentsixteenoneremark7 = data.data.response.commentsixteenoneremark7 || "";

                tempInitialValues.typeofcontrolsseventeenone = data.data.response.typeofcontrolsseventeenone || "OC";
                tempInitialValues.systemtestingseventeenoneremark = data.data.response.systemtestingseventeenoneremark || "";
                tempInitialValues.visualseventeenoneremark = data.data.response.visualseventeenoneremark || "";
                tempInitialValues.typeofstatusseventeenone = data.data.response.typeofstatusseventeenone || "O";
                tempInitialValues.commentseventeenoneremark = data.data.response.commentseventeenoneremark || "";

                tempInitialValues.typeofcontrolsseventeenone1 = data.data.response.typeofcontrolsseventeenone1 || "OC";
                tempInitialValues.systemtestingseventeenoneremark1 = data.data.response.systemtestingseventeenoneremark1 || "";
                tempInitialValues.visualseventeenoneremark1 = data.data.response.visualseventeenoneremark1 || "";
                tempInitialValues.typeofstatusseventeenone1 = data.data.response.typeofstatusseventeenone1 || "O";
                tempInitialValues.commentseventeenoneremark1 = data.data.response.commentseventeenoneremark1 || "";

                tempInitialValues.typeofcontrolsseventeenone2 = data.data.response.typeofcontrolsseventeenone2 || "OC";
                tempInitialValues.systemtestingseventeenoneremark2 = data.data.response.systemtestingseventeenoneremark2 || "";
                tempInitialValues.visualseventeenoneremark2 = data.data.response.visualseventeenoneremark2 || "";
                tempInitialValues.typeofstatusseventeenone2 = data.data.response.typeofstatusseventeenone2 || "O";
                tempInitialValues.commentseventeenoneremark2 = data.data.response.commentseventeenoneremark2 || "";

                tempInitialValues.typeofcontrolsseventeenone3 = data.data.response.typeofcontrolsseventeenone3 || "OC";
                tempInitialValues.systemtestingseventeenoneremark3 = data.data.response.systemtestingseventeenoneremark3 || "";
                tempInitialValues.visualseventeenoneremark3 = data.data.response.visualseventeenoneremark3 || "";
                tempInitialValues.typeofstatusseventeenone3 = data.data.response.typeofstatusseventeenone3 || "O";
                tempInitialValues.commentseventeenoneremark3 = data.data.response.commentseventeenoneremark3 || "";

                tempInitialValues.typeofcontrolsseventeentwo = data.data.response.typeofcontrolsseventeentwo || "OC";
                tempInitialValues.systemtestingseventeentworemark = data.data.response.systemtestingseventeentworemark || "";
                tempInitialValues.visualseventeentworemark = data.data.response.visualseventeentworemark || "";
                tempInitialValues.typeofstatusseventeentwo = data.data.response.typeofstatusseventeentwo || "O";
                tempInitialValues.commentseventeentworemark = data.data.response.commentseventeentworemark || "";

                tempInitialValues.typeofcontrolsseventeentwo1 = data.data.response.typeofcontrolsseventeentwo1 || "OC";
                tempInitialValues.systemtestingseventeentworemark1 = data.data.response.systemtestingseventeentworemark1 || "";
                tempInitialValues.visualseventeentworemark1 = data.data.response.visualseventeentworemark1 || "";
                tempInitialValues.typeofstatusseventeentwo1 = data.data.response.typeofstatusseventeentwo1 || "O";
                tempInitialValues.commentseventeentworemark1 = data.data.response.commentseventeentworemark1 || "";

                tempInitialValues.typeofcontrolseighteenone = data.data.response.typeofcontrolseighteenone || "OC";
                tempInitialValues.systemtestingeighteenoneremark = data.data.response.systemtestingeighteenoneremark || "";
                tempInitialValues.visualeighteenoneremark = data.data.response.visualeighteenoneremark || "";
                tempInitialValues.typeofstatuseighteenone = data.data.response.typeofstatuseighteenone || "O";
                tempInitialValues.commenteighteenoneremark = data.data.response.commenteighteenoneremark || "";

                tempInitialValues.typeofcontrolseighteenone1 = data.data.response.typeofcontrolseighteenone1 || "OC";
                tempInitialValues.systemtestingeighteenoneremark1 = data.data.response.systemtestingeighteenoneremark1 || "";
                tempInitialValues.visualeighteenoneremark1 = data.data.response.visualeighteenoneremark1 || "";
                tempInitialValues.typeofstatuseighteenone1 = data.data.response.typeofstatuseighteenone1 || "O";
                tempInitialValues.commenteighteenoneremark1 = data.data.response.commenteighteenoneremark1 || "";

                tempInitialValues.typeofcontrolseighteenone2 = data.data.response.typeofcontrolseighteenone2 || "OC";
                tempInitialValues.systemtestingeighteenoneremark2 = data.data.response.systemtestingeighteenoneremark2 || "";
                tempInitialValues.visualeighteenoneremark2 = data.data.response.visualeighteenoneremark2 || "";
                tempInitialValues.typeofstatuseighteenone2 = data.data.response.typeofstatuseighteenone2 || "O";
                tempInitialValues.commenteighteenoneremark2 = data.data.response.commenteighteenoneremark2 || "";

                tempInitialValues.typeofcontrolseighteenone3 = data.data.response.typeofcontrolseighteenone3 || "OC";
                tempInitialValues.systemtestingeighteenoneremark3 = data.data.response.systemtestingeighteenoneremark3 || "";
                tempInitialValues.visualeighteenoneremark3 = data.data.response.visualeighteenoneremark3 || "";
                tempInitialValues.typeofstatuseighteenone3 = data.data.response.typeofstatuseighteenone3 || "O";
                tempInitialValues.commenteighteenoneremark3 = data.data.response.commenteighteenoneremark3 || "";

                tempInitialValues.typeofcontrolseighteenone4 = data.data.response.typeofcontrolseighteenone4 || "OC";
                tempInitialValues.systemtestingeighteenoneremark4 = data.data.response.systemtestingeighteenoneremark4 || "";
                tempInitialValues.visualeighteenoneremark4 = data.data.response.visualeighteenoneremark4 || "";
                tempInitialValues.typeofstatuseighteenone4 = data.data.response.typeofstatuseighteenone4 || "O";
                tempInitialValues.commenteighteenoneremark4 = data.data.response.commenteighteenoneremark4 || "";

                tempInitialValues.typeofcontrolseighteenone5 = data.data.response.typeofcontrolseighteenone5 || "OC";
                tempInitialValues.systemtestingeighteenoneremark5 = data.data.response.systemtestingeighteenoneremark5 || "";
                tempInitialValues.visualeighteenoneremark5 = data.data.response.visualeighteenoneremark5 || "";
                tempInitialValues.typeofstatuseighteenone5 = data.data.response.typeofstatuseighteenone5 || "O";
                tempInitialValues.commenteighteenoneremark5 = data.data.response.commenteighteenoneremark5 || "";

                tempInitialValues.typeofcontrolseighteentwo = data.data.response.typeofcontrolseighteentwo || "OC";
                tempInitialValues.systemtestingeighteentworemark = data.data.response.systemtestingeighteentworemark || "";
                tempInitialValues.visualeighteentworemark = data.data.response.visualeighteentworemark || "";
                tempInitialValues.typeofstatuseighteentwo = data.data.response.typeofstatuseighteentwo || "O";
                tempInitialValues.commenteighteentworemark = data.data.response.commenteighteentworemark || "";

                tempInitialValues.typeofcontrolseighteentwo1 = data.data.response.typeofcontrolseighteentwo1 || "OC";
                tempInitialValues.systemtestingeighteentworemark1 = data.data.response.systemtestingeighteentworemark1 || "";
                tempInitialValues.visualeighteentworemark1 = data.data.response.visualeighteentworemark1 || "";
                tempInitialValues.typeofstatuseighteentwo1 = data.data.response.typeofstatuseighteentwo1 || "O";
                tempInitialValues.commenteighteentworemark1 = data.data.response.commenteighteentworemark1 || "";

                tempInitialValues.typeofcontrolseighteentwo2 = data.data.response.typeofcontrolseighteentwo2 || "OC";
                tempInitialValues.systemtestingeighteentworemark2 = data.data.response.systemtestingeighteentworemark2 || "";
                tempInitialValues.visualeighteentworemark2 = data.data.response.visualeighteentworemark2 || "";
                tempInitialValues.typeofstatuseighteentwo2 = data.data.response.typeofstatuseighteentwo2 || "O";
                tempInitialValues.commenteighteentworemark2 = data.data.response.commenteighteentworemark2 || "";

                tempInitialValues.typeofcontrolseighteentwo3 = data.data.response.typeofcontrolseighteentwo3 || "OC";
                tempInitialValues.systemtestingeighteentworemark3 = data.data.response.systemtestingeighteentworemark3 || "";
                tempInitialValues.visualeighteentworemark3 = data.data.response.visualeighteentworemark3 || "";
                tempInitialValues.typeofstatuseighteentwo3 = data.data.response.typeofstatuseighteentwo3 || "O";
                tempInitialValues.commenteighteentworemark3 = data.data.response.commenteighteentworemark3 || "";

                tempInitialValues.processAuditReportDetails = data.data.response.processAuditReportDetails.length > 0 ? data.data.response.processAuditReportDetails : [{
                    nameofprocess: "",
                    nameofprocessid: "",
                    processowner: "",
                    details: "",
                    reference: "",
                    comments: "",
                    clausesList: [],
                    clauseWiseObservation: [{ clauseNo: "", Observation: "" }],
                }]

                if (data.data.response.processAuditReportDetails.length > 0) {
                    for (let j = 0; j < tempInitialValues.processAuditReportDetails.length; j++) {
                        console.log("processAuditReportDetails.nameodprocess ", tempInitialValues.processAuditReportDetails[j].nameofprocess)
                        var clauseListdata = processList.data.response.find(e => e.label === tempInitialValues.processAuditReportDetails[j].nameofprocess)
                        console.log("clause List data", clauseListdata)
                        if (clauseListdata) {
                            tempInitialValues.processAuditReportDetails[j].clausesList = clauseListdata.clausesList
                        }
                    }
                } else {

                }

                tempInitialValues.nacecode = data.data.response.nabcbcode
                if (tempInitialValues.nacecode && tempInitialValues.nacecode !== "") {

                    mutationLeadAudiorDetails.mutate(tempInitialValues.nacecode)
                }
                if (tempInitialValues.nacecode && tempInitialValues.nacecode !== "") {
                    mutationTechnicalExpertDetails.mutate(tempInitialValues.nacecode)
                }
                if (tempInitialValues.nabcbcode && tempInitialValues.nabcbcode !== "") {
                    mutationAssisAuditorDetails.mutate(tempInitialValues.nabcbcode)
                }
                if (tempInitialValues.nabcbcode && tempInitialValues.nabcbcode !== "") {
                    mutationAuditorListDetails.mutate(tempInitialValues.nabcbcode)
                }

                setInitialValues(tempInitialValues)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
        }
    })
    const mutationLeadAudiorDetails = useMutation((params) => Fetcher('get', '/api/profile/get/keyvalueforleadauditorsCommonNacecode/' + params, {}), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {
                console.log("List of Auditor", data.data.response)
                setLeadauditorList(data.data.response)
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const mutationTechnicalExpertDetails = useMutation((params) => Fetcher('get', '/api/technicalexpert/get/labelvalueTechnicalExpertCommonNacecode/' + params, {}), {
        onSuccess(data) {
            console.log("data expert", data)

            if (data.data.errorCode === 0) {
                console.log("List of Technical Expert", data.data.response)
                setTechnicalExpertList(data.data.response)
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {

            ToastInstance('Error', 'Subject' + error)
        }
    })
    const getUrl = () => {
        const api = APIURL + '/api/rfq/get/orgdetails/' + orgcode
        axios.get(api, { headers: { "Authorization": 'Bearer ' + localStorage.getItem("token") } })
            .then(Rfqdata => {
                console.log("Rfqdata.data.response", Rfqdata.data.response)
                if (Rfqdata && initialValues.orgCode === 0 && Rfqdata.data.response.masteragreementStatus === true) {
                    var tempData = Rfqdata.data.response
                    tempData.dateofaudit = Date.parse(tempData.dateofaudit);
                    tempData.auditdate1 = Date.parse(tempData.auditdate1);
                    tempData.auditdate2 = Date.parse(tempData.auditdate2);

                    var temp2 = tempData.processAuditReportDetails.map((clno) => clno)

                    tempData.processAuditReportDetails = tempData.processAuditReportDetails.length > 0 ? tempData.processAuditReportDetails : [{
                        nameofprocess: "",
                        nameofprocessid: "",
                        processowner: "",
                        details: "",
                        reference: "",
                        comments: "",
                        clauseWiseObservation: [{ clauseNo: "", Observation: "" }],
                        clausesList: [],


                    }]
                    if (Rfqdata.data.response.processAuditReportDetails.length > 0) {
                        for (let j = 0; j < tempData.processAuditReportDetails.length; j++) {
                            console.log("processAuditReportDetails.nameodprocess ", tempData.processAuditReportDetails[j].nameofprocess)
                            var clauseListdata = processList.data.response.find(e => e.label === tempData.processAuditReportDetails[j].nameofprocess)
                            console.log("clause List data", clauseListdata)
                            if (clauseListdata) {
                                tempData.processAuditReportDetails[j].clausesList = clauseListdata.clausesList
                            }
                        }
                    }

                    setInitialValues(tempData)
                    if (tempData.nabcbcode && tempData.nabcbcode !== "") {
                        mutationLeadAudiorDetails.mutate(tempData.nabcbcode)
                    }
                    if (tempData.nabcbcode && tempData.nabcbcode !== "") {
                        mutationAssisAuditorDetails.mutate(tempData.nabcbcode)
                    }
                    if (tempData.nacecode && tempData.nacecode !== "") {
                        mutationTechnicalExpertDetails.mutate(tempData.nacecode)
                    }

                }
            })
            .catch(err => {
                var string = JSON.stringify(err).split("/")[0]
                const regex = /401/g;
                const found = string.match(regex);

                console.log("found", found);
                if (found !== null) {
                    console.log(err)
                    window.location.href = "/signin"
                }


            })
    }

    useEffect(() => {
        if (orgcode !== undefined) {
            getUrl()
        }

    }, [orgcode !== undefined])


    const { data: nacecodeList, isLoading: nacecodeListLoading } = useQuery(
        'listnacecode',
        () => Fetcher('get', '/api/nace/get/listnacecodewithkeylabel', {}))

    const { data: OrgList, isLoading: companyListLoading } = useQuery(
        'listAuditPlan',
        () => Fetcher('get', '/api/clientaccess/get/listofcompaniesstage1audreportdata/' + localStorage.getItem("userCode"), {}))

    // const onSubmitHandler = () => {
    //     history.push("/" + localStorage.getItem("role") + '/stage1auditreport1');
    // }
    if (companyListLoading || nacecodeListLoading) return <h1>Loading</h1>
    if (orgcode && initialValues.orgCode === 0) {

        //  window.location.href = "/signin"
        return <h1>Loading Data</h1>

    }
    return (
        <div>
            <Formik
                enableReinitialize={true}
                // validationSchema={ValidationSchema}
                initialValues={initialValues}
                onSubmit={onSubmit}
            >
                {
                    formik => (
                        <Form>
                            <div className="content-wrapper">
                                <section className="content">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="card-body">
                                                    <div className="formOuterDiv">
                                                        <div className="hrstyle headingcolor">
                                                            <h5>General Information</h5>
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='selectNACECode' label='Company Name' options={OrgList.data.response} name='orgCode' onChange={e => { mutationgetCompanyDetails.mutate(e.value); }} />
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type='text' label='Address' name='address' disabled={true} />
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type='text' label='Site Address' name='siteofaddress' />
                                                        </div>
                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type='text' label='No. of employees' name='total' disabled={true} />
                                                            <FormikControl control='date' type="text" label='Date of Audit' name='dateofaudit' disabled={true} dateFormat="dd-MM-yyyy" />
                                                        </div>
                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type="text" label='Mobile' name='mobile' disabled={true} />
                                                            <FormikControl control='input' type="text" label='Email' name='email' disabled={true} />
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type="text" label='No of Server' name='noofserver' disabled={true} />
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type="text" label='Number of WS+PC+Laptop' name='noofwspclp' disabled={true} />
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type="text" label='DataCenter  Details(If Present)' name='datacenterdetails' disabled={true} />
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type="text" label='No of Application user' name='noofappluser' disabled={true} />
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type="text" label='No of Infrastructure user(Pc/laptop etc)' name='noofinfrauser' disabled={true} />
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type='text' label='No. of Application Development and Maintenance staff *' name='noofappdev' />
                                                        </div>

                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type='text' label='Scope' name='scope' disabled={true} />
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type='text' label='Audit Objective' name='auditobject' />
                                                        </div>
                                                        <div className="hrstyle headingcolor">
                                                            <h5>Audit Team</h5>
                                                        </div>

                                                        <div className="form2RowDiv">
                                                            <FormikControl control="selectNACECode" name="teamleader" label="Team Leader/ Lead Auditor *" options={leadauditorList}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`teamleader`, parseInt(e.value))
                                                                    formik.setFieldValue(`teamleaderName`, e.label)
                                                                }}
                                                            />

                                                            <FormikControl control='selectNACECode' label='Technical Expert' options={technicalExpertList} name='technicalexpert'
                                                                onChange={(e) => {

                                                                    formik.setFieldValue(`technicalexpert`, e.value)
                                                                    formik.setFieldValue(`technicalExpertName`, e.label)
                                                                }}

                                                                values={(technicalExpertList).find(i => i.value === `technicalexpert`)} />

                                                        </div>
                                                        <div className="form2RowDiv">
                                                            <FormikControl control="selectNACECode" name="auditorOne" label='Auditor One' options={assitAuditorList}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`auditorOne`, parseInt(e.value))
                                                                    formik.setFieldValue(`auditorOneName`, e.label)
                                                                }}
                                                            />

                                                            <FormikControl control="selectNACECode" name="auditorTwo" label='Auditor Two' options={assitAuditorList}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`auditorTwo`, e.value)
                                                                    formik.setFieldValue(`auditorTwoName`, e.label)
                                                                }}
                                                            />

                                                        </div>
                                                        <div className="hrstyle headingcolor">
                                                            <h5>Audit Mandays</h5>
                                                        </div>


                                                        <div className="form2RowDiv">

                                                            <FormikControl control='input' type='text' label=' Stage 1 Mandays *' name='stageOneAudit' style={{ textAlign: "right" }} />
                                                            <FormikControl control='date' type='text' label=' Stage 1 Audit Date *' name='auditdate1' dateFormat="dd-MM-yyyy" />
                                                        </div>

                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type='text' label=' Stage 2 Mandays *' name='stageTwoAudit' style={{ textAlign: "right" }} />
                                                            <FormikControl control='date' type='text' label='  Stage 2 Audit Date *' name='auditdate2' dateFormat="dd-MM-yyyy" />
                                                        </div>
                                                        <div className="hrstyle headingcolor">
                                                            <h5>Verification of the Audit Duration</h5>
                                                        </div>
                                                        <div className="row">
                                                            <div className="row" style={{ marginLeft: "0.5%" }}>
                                                                <label htmlFor="staticEmail" className="col-sm-9">Are quoted man-days adequate?
                                                                    <span className="required-field"> * </span>
                                                                </label>
                                                                <div className="col-sm-2 mt-3">
                                                                    <FormikControl control='radio' name='areqquatedmandays' options={options} />
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{ marginLeft: "0.5%" }}>
                                                                <label htmlFor="staticEmail" className="col-sm-9">Is there any change in employee detail after application?
                                                                    <span className="required-field"> * </span>
                                                                </label>
                                                                <div className="col-sm-2 mt-3">
                                                                    <FormikControl control='radio' name='istherechangeemployee' options={options} />
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{ marginLeft: "0.5%" }}>
                                                                <label htmlFor="staticEmail" className="col-sm-9">Is there any change in Scope?
                                                                    <span className="required-field"> * </span>
                                                                </label>
                                                                <div className="col-sm-2 mt-3">
                                                                    <FormikControl control='radio' name='istherechangescope' options={options} />
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{ marginLeft: "0.5%" }}>
                                                                <label htmlFor="staticEmail" className="col-sm-9">Is there any information or Event accrued after the application date which may affect the Man-days?
                                                                    <span className="required-field"> * </span>
                                                                </label>
                                                                <div className="col-sm-2 mt-3">
                                                                    <FormikControl control='radio' name='isthereanyinforevent' options={options} />
                                                                </div>
                                                            </div>

                                                            <div className="fieldarray mt-3">

                                                                <FieldArray name='processAuditReportDetails'>

                                                                    {fieldArrayProps => {
                                                                        const { push, remove, form } = fieldArrayProps
                                                                        const { values } = form
                                                                        const { processAuditReportDetails } = values
                                                                        return (
                                                                            <div>
                                                                                {processAuditReportDetails.map((processDetail, index) => (
                                                                                    <div key={index}>
                                                                                        <div className="form2RowDiv">
                                                                                            <div className="formSingleElement">
                                                                                                <FormikControl control="selectNACECode" name={`processAuditReportDetails[${index}].nameofprocessid`} label='Name of the Process' options={processList.data.response}
                                                                                                    onChange={(e) => {

                                                                                                        var fillteredprocess = processAuditReportDetails.find(x => x.nameofprocessid === e.value)

                                                                                                        if (fillteredprocess) {
                                                                                                            swal({
                                                                                                                title: "Process is Already selected",
                                                                                                                icon: "warning",
                                                                                                                dangerMode: true,
                                                                                                            })
                                                                                                        } else {
                                                                                                            formik.setFieldValue(`processAuditReportDetails[${index}].nameofprocess`, e.label)
                                                                                                            formik.setFieldValue(`processAuditReportDetails[${index}].nameofprocessid`, e.value)

                                                                                                            formik.setFieldValue(`processAuditReportDetails[${index}].reference`, e.listClauses)

                                                                                                            formik.setFieldValue(`processAuditReportDetails[${index}].clausesList`, e.clausesList)


                                                                                                        }

                                                                                                    }

                                                                                                    } />

                                                                                            </div>
                                                                                            <div className="formSingleElement">
                                                                                                <label className="formSingleElementLabel">Process Owner</label>
                                                                                                <Field className="form-control" name={`processAuditReportDetails[${index}].processowner`} />
                                                                                                <div style={{ color: "red", fontSize: "15px" }}>
                                                                                                    <ErrorMessage name={`processAuditReportDetails[${index}].processowner`} />
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>


                                                                                        <div className="form1RowDiv ">
                                                                                            <div className="formSingleElement">
                                                                                                <label className="formSingleElementLabel">References</label>
                                                                                                <Field className="form-control" name={`processAuditReportDetails[${index}].reference`} />
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="row mt-5" style={{ margin: "1%" }}>

                                                                                            <div className="col-sm-11">
                                                                                                <label htmlFor="staticEmail" className="col-sm-5 mt-1 mb-1">Details</label>
                                                                                                <FormikControl control='ckEditor' name={`processAuditReportDetails[${index}].details`} className="form-control" data={initialValues.processAuditReportDetails.details} />
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="row mt-3" style={{ margin: "1%" }}>
                                                                                            <label className="formSingleElementLabel">Auditor comments on</label>
                                                                                            <Field as='textarea' className="form-control" name={`processAuditReportDetails[${index}].comments`} />
                                                                                            <div style={{ color: "red" }}>
                                                                                                <ErrorMessage name={`processAuditReportDetails[${index}].comments`} />
                                                                                            </div>

                                                                                        </div>

                                                                                        <div className="fieldarray mt-3">

                                                                                            <FieldArray name={`processAuditReportDetails[${index}].clauseWiseObservation`}>

                                                                                                {fieldArrayProps => {
                                                                                                    const { push, remove, form } = fieldArrayProps
                                                                                                    const { values } = form
                                                                                                    const { clauseWiseObservation } = values
                                                                                                    return (
                                                                                                        <div>
                                                                                                            {processAuditReportDetails[index].clauseWiseObservation.map((clauseDetail, i) => (
                                                                                                                <div key={index}>
                                                                                                                    <div className="form2RowDiv">
                                                                                                                        <div className="formSingleElement">
                                                                                                                            {<FormikControl control="selectNACECode" name={`processAuditReportDetails[${index}].clauseWiseObservation[${i}].clauseNo`} label='Clause' options={processAuditReportDetails[index].clausesList}
                                                                                                                                onChange={(e) => {

                                                                                                                                    var fillteredprocess = processAuditReportDetails[index].clauseWiseObservation.find(x => x.clauseNo === e.value)

                                                                                                                                    if (fillteredprocess) {
                                                                                                                                        swal({
                                                                                                                                            title: "Clause is Already selected",
                                                                                                                                            icon: "warning",
                                                                                                                                            dangerMode: true,
                                                                                                                                        })
                                                                                                                                    } else {
                                                                                                                                        var fillteredprocess = processAuditReportDetails[index].clauseWiseObservation.find(x => x.clauseNo === e.value)

                                                                                                                                        if (fillteredprocess) {
                                                                                                                                            swal({
                                                                                                                                                title: "Clause is Already selected",
                                                                                                                                                icon: "warning",
                                                                                                                                                dangerMode: true,
                                                                                                                                            })
                                                                                                                                        } else {

                                                                                                                                            formik.setFieldValue(`processAuditReportDetails[${index}].clauseWiseObservation[${i}].clauseNo`, e.value)

                                                                                                                                        }
                                                                                                                                    }

                                                                                                                                }

                                                                                                                                }
                                                                                                                            />}

                                                                                                                        </div>
                                                                                                                        <div className="formSingleElement">
                                                                                                                            <label className="formSingleElementLabel">Observation</label>
                                                                                                                            <Field as='textarea' className="form-control" name={`processAuditReportDetails[${index}].clauseWiseObservation[${i}].Observation`} />
                                                                                                                            <div style={{ color: "red" }}>
                                                                                                                                <ErrorMessage name={`processAuditReportDetails[${index}].clauseWiseObservation[${i}].Observation`} />
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    </div>

                                                                                                                    {i > 0 && (
                                                                                                                        <div className="col-sm-4">
                                                                                                                            <span style={{ "marginLeft": "290%", "cursor": "pointer" }} onClick={() => remove(i)}><AiIcons.AiOutlineDelete style={{ widh: "30px", fill: "red" }} /></span>
                                                                                                                        </div>
                                                                                                                    )}

                                                                                                                    <hr />

                                                                                                                </div>

                                                                                                            ))}


                                                                                                            <div className="row mt-3">
                                                                                                                <div className="col-lg-11"></div>
                                                                                                                <div className="col-lg-1 mb-3" >
                                                                                                                    <button type='button' className="btn btn-primary" onClick={() => push({
                                                                                                                        clauseNo: "",
                                                                                                                        Observation: "",

                                                                                                                    })}> + </button>
                                                                                                                </div>
                                                                                                            </div>


                                                                                                        </div>

                                                                                                    )
                                                                                                }}
                                                                                            </FieldArray>



                                                                                        </div>
                                                                                        {index > 0 && (
                                                                                            <div className="col-sm-4">
                                                                                                <span style={{ "marginLeft": "290%", "cursor": "pointer" }} onClick={() => remove(index)}><AiIcons.AiOutlineDelete style={{ widh: "30px", fill: "red" }} /></span>
                                                                                            </div>
                                                                                        )}
                                                                                        <hr />
                                                                                    </div>

                                                                                ))}
                                                                                <div className="row mt-3">
                                                                                    <div className="col-lg-11"></div>
                                                                                    <div className="col-lg-1 mb-3" >
                                                                                        <button type='button' className="btn btn-primary" onClick={() => push({
                                                                                            nameofprocess: "",
                                                                                            nameofprocessid: "",
                                                                                            processowner: "",
                                                                                            details: "",
                                                                                            reference: "",
                                                                                            comments: "",
                                                                                            clauseWiseObservation: [{ clauseNo: "", Observation: "" }]

                                                                                        })}>Add</button>
                                                                                    </div>
                                                                                </div>


                                                                            </div>

                                                                        )
                                                                    }}
                                                                </FieldArray>
                                                                <hr />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>

                            <div className="card-footer">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        <button type="submit" className="btn btn-primary float-right">Next</button>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    )}
            </Formik>
        </div>

    )
}

export default Stage1AuditReport